export default {
    "accountValidateMsg" : "Akun terdiri dari 6-30 karakter, menggunakan huruf, angka, dan simbol (\".\",\"_\",\"@\"). Karakter pertama harus berupa angka atau huruf.",
    "storeSuccess" : "Top Up berhasil",
    "editAccountTips" : "Masukkan nama akun yang valid",
    "editPwdTips" : "Masukkan Password yang valid",
    "editRepeatPwdTips" : "Masukkan kembali Password",
    "pwdRepeatTips" : "Password tidak sama",
    "changePwdSucc" : "Berhasil mengubah Password",
    "bindEmail" : "Tautkan E-mail",
    "verifyEmail" : "Verifikasi Keamanan Akun",
    "errorVrifyCodeTips" : "Kode verifikasi salah",
    "slectQuessionTips" : "Silakan pilih pertanyaan keamanan",
    "answerTips" : "Silakan masukkan jawaban",
    "twoAnswerTips" : "Pilih pertanyaan keamanan Anda dan masukkan jawaban yang benar.",
    "realNameValidateTips" : "Nama lengkap (4-60 karakter)",
    "phoneValidateTips" : "Nomor Telp (6-18 digit)",
    "areaSelectTips" : "Pilih negara",
    "iDCardValidataTips" : "Masukkan No.KTP/Paspor (1-60 digit)",
    "changeProfileSucc" : "Berhasil mengubah profil",
    "editVrfCodeTips" : "Silakan masukkan kode verifikasi",
    "securityQuestionTips" : "Atur pertanyaan keamanan untuk meningkatkan keamanan akun Anda. Anda dapat mengatur ulang Password dengan menjawab pertanyaan keamanan.",
    "validateQuessionTips" : "Pilih dua pertanyaan untuk verifikasi. Anda dapat mengatur ulang pertanyaan setelahnya.",
    "originPwd" : "Silakan masukkan Password lama",
    "newPwd" : "Silakan masukkan Password baru",
    "changePwdSuccess" : "Password berhasil diubah. Silakan Log-in kembali untuk menyimpan data Anda.",
    "accountName" : "Masukkan nama akun",
    "password" : "Silakan masukkan Password",
    "repeatPassword" : "Masukkan kembali Password",
    "findPwdTips" : "Masukkan akun untuk pemulihan Password",
    "submit" : "Kirim",
    "send" : "Kirim",
    "modify" : "Ubah",
    "haveAgree" : "Saya setuju",
    "and" : "dan",
    "privacyPolicy" : "Kebijakan privasi",
    "completeness" : "Penyelesaian:",
    "gender" : "Jenis Kelamin",
    "male" : "Pria",
    "female" : "Wanita",
    "birthday" : "Tanggal Lahir",
    "phone" : "Telepon",
    "region" : "Negara/Wilayah",
    "ID" : "No. KTP/Paspor",
    "accountSetting" : "Setelan Akun",
    "upgrade" : "Tingkatkan Akun",
    "profile" : "Profil",
    "changePassword" : "Ubah Password",
    "securityQuestion" : "Pertanyaan Keamanan",
    "creatework_headerTitle" : "Buat tiket",
    "mylist_headerTitle" : "Tiket saya",
    "bindEmailTips" : "Verifikasi E-mail Anda untuk meningkatkan keamanan akun Anda. Pemulihan Password akan dikirimkan ke E-mail tersebut.",
    "verifyEmailTips" : "Terdeteksi akun Anda sedang masuk dari perangkat baru atau lingkungan yang tidak biasa. Untuk melindungi aset akun, silakan selesaikan verifikasi identitas.",
    "enterEmailVrfcationTips" : "Masukkan kode verifkasi",
    "cancel" : "Batal",
    "bindTps" : "Tautkan akun Anda agar dapat bermain di perangkat yang berbeda-beda!",
    "login" : "Log In",
    "logout" : "Log Out",
    "bind" : "Tautkan Akun",
    "feedback" : "Penilaian",
    "terms" : "Ketentuan",
    "tips" : "Tips",
    "debindTips" : "Menghapus tautan berisiko kehilangan data. Yakin hapus tautan?",
    "debindText" : "Hapus Tautan",
    "guestSwitchTips" : "Saat ini Anda sudah memiliki akun tamu. Data akun tamu akan hilang setelah Anda Log In. Lanjutkan?",
    "register" : "Registrasi",
    "realName" : "Nama Lengkap",
    "enterEmailTips" : "Masukkan alamat E-mail",
    "emailVAlidateMsg" : "Format E-mail bermasalah",
    "editEmaileTips" : "Masukkan alamat E-mail",
    "checkServiceTips" : "Silakan baca dan menerima Persyaratan Layanan dan Kebijakan Privasi!",
    "brithdayValidateTips" : "Pilih tanggal lahir Anda",
    "facebookValidateTips" : "Masukkan akun Facebook (1-60 karakter)",
    "eritOriginPwdTips" : "Masukkan Password sebelumnya",
    "submitSuccess" : "Berhasil mengirim",
    "rebindEmail" : "Ubah E-mail",
    "bindEmailSuccess" : "E-mail tautan: \$email</br>Verifikasi dengan E-mail tautan. Anda bisa set ulang E-mail setelah verifikasi.",
    "reSetSecurityQuessoon" : "Berhasil mengatur pertanyaan keamanan<br/><br/>Verifikasi dengan memilih pertanyaan yang berbeda. Anda bisa set ulang pertanyaan setelah verifikasi.",
    "canotModifyTips" : "Profil TIDAK bisa diubah setelah dikirimkan. Yakin kirimkan?",
    "rebindEmailTips" : "E-mail Anda: \$email. Klik di sini untuk mendapatkan kode verifikasi",
    "reGetVrfCode" : "Dapatkan kode",
    "findPwdWayTips" : "Pilih salah 1 metode di bawah",
    "emailWay" : "Pulihkan dengan E-mail keamanan",
    "emailWayTips" : "Kamu akan menerima E-mail konfirmasi untuk mengatur ulang Password.",
    "quessionWay" : "Pulihkan dengan pertanyaan keamanan",
    "quessionWayTips" : "Jawab pertanyaan keamanan dengan benar untuk mengatur ulang Password",
    "resetPwdBtn" : "Atur ulang Password",
    "lastStep" : "Sebelumnya",
    "sendEmailTips" : "Kode verifikasi sudah dikirimkan ke \$email.<br>Masukkan kode verifikasi yang Anda terima.",
    "setNewPwdTips" : "Selamat!<br>Anda sudah bisa mengatur ulang Password. Masukkan Password baru Anda di kolom teks.",
    "termsOfUse" : "Persyaratan Layanan",
    "copy_success" : "Berhasil disalin",
    "creatework_create" : "Tiket",
    "creatework_createHolder" : "Pilih kategori",
    "creatework_title" : "Judul",
    "creatework_titleHolder" : "Masukkan judul",
    "creatework_detail" : "Deskripsi kendala",
    "creatework_detailHolder" : "Deskripsi maksimal 200 karakter",
    "creatework_uploadTips" : "Unggah berkas dengan format jpg/png, ukuran maksimal 5MB.",
    "creatework_selectBox_selectTile" : "Kategori",
    "creatework_goGame" : "Kembali",
    "creatework_history" : "Riwayat",
    "mylist_noYet" : "Tidak ada riwayat",
    "mywork_solved" : "Kendala terselesaikan?",
    "mywork_service" : "Berikan penilaian",
    "mywork_messageHolder" : "Masukkan pesan baru",
    "mywork_score" : "Pilih skor",
    "mywork_confirm" : "Konfirmasi",
    "creatework_selectBox_selectList3" : "Lainnya",
    "creatework_selectBox_selectList2" : "Akun",
    "close" : "Tutup",
    "creatework_gameHolder" : "Pilih Game",
    "creatework_serverHolder" : "Pilih Server",
    "contactService" : "Hubungi CS",
    "FAQ" : "FAQ",
    "creatework_game" : "Game:",
    "creatework_server" : "Server:",
    "creatework_role" : "Karakter:",
    "selectRoleName" : "Pilih karakter",
    "creatework_noRole" : "Belum ada karakter",
    "creatework_noGame" : "Daftar Game kosong",
    "creatework_noServer" : "Daftar Server kosong",
    "termText" : "Saya setuju {mainHost}",
    "backLogin" : "Tolak",
    "creatework_roleHolder" : "Silakan kunjungi setelah pilih karakter",
    "findPwdFailTips" : "Anda belum mengatur pertanyaan dan E-mail keamanan. Harap hubungi CS.",
    "payMall" : "Mall",
    "selectPayment" : "Harga",
    "plzSelectPayWay" : "Pilih Kanal",
    "gainPlus" : "Tambah",
    "gainMorePlus" : "Tambah lagi",
    "gainMostPlus" : "Maks",
    "plzSelectPayType" : "Pilih Metode Pembayaran",
    "roleName" : "Karakter",
    "payWay" : "Kanal Pembayaran",
    "plzSelectOtherWay" : "Kanal Pembayaran lainnya",
    "payment" : "Total Harga",
    "compensateTips" : "Kelebihannya akan dikembalikan untukmu dalam \$gameCode",
    "extaGain" : "Bonus",
    "gameGold" : "Mata uang Game",
    "compensate" : "Kompensasi",
    "payWayPlus" : "Bonus Kanal",
    "neddPay" : "Bayar",
    "submitOrder" : "Pesan",
    "screenshotTips" : "Tips: Pastikan untuk menyimpan screenshot order Anda jika sewaktu-waktu terjadi kendala!",
    "storeFail" : "Gagal Top Up",
    "storeFailTips" : "Transaksi gagal. Silakan ulangi pemesanan atau hubungi CS kami.",
    "storeAcceptance" : "Dalam proses",
    "storeSuccessTips" : "Top Up akan dikirimkan dalam 15 menit. Periksa kembali selang beberapa saat.",
    "orderNumber" : "Nomor Order",
    "buyProduct" : "Top Up Item",
    "transactionAmount" : "Jumlah",
    "failReason" : "Alasan",
    "payOntherORder" : "Order baru",
    "reStore" : "Top Up lagi",
    "confirm" : "Konfirmasi",
    "switch" : "Ganti Akun",
    "completeTips" : "Masukkan data pribadi Anda. <mark class=\"yellowMarkColor\">Data tidak bisa diubah</mark>. Anda akan diminta untuk memberikan data pribadi yang sebenarnya pada proses pemulihan akun.",
    "creatework_selectBox_selectList0" : "Gameplay",
    "creatework_selectBox_selectList1" : "Pembayaran Bermasalah",
    "creatework_selectBox_selectList4" : "Terjemahan Bermasalah",
    "mywork_solvedText" : "Kendala teratasi",
    "browserPayErrBtnText" : "Transaksi Bermasalah",
    "browserPaySucBtnText" : "Pembayaran selesai",
    "browserPayingTips" : "Anda akan dialihkan ke Platform pihak ketiga untuk membayar.<br/>Halaman bisa ditutup setelah pembayaran.",
    "price_list_empty" : "Tidak ada pilihan nominal",
    "pointCardTips" : "Tips: Item ini hanya menerima pembayaran kartu \$paymentAmount",
    "forgetPwd" : "Lupa Password",
    "payCenter" : "Pusat Top Up",
    "willGet" : "Anda akan mendapatkan",
    "goods" : "Item",
    "discount" : "Bonus",
    "payDiscount" : "Kompensasi",
    "payDiscountTips" : "Poin ekstra akan dikonversi menjadi Diamond",
    "hasQuestionPlease" : "Jika ada pertanyaan, silakan",
    "pwdValidateMsg" : "Password terdiri dari 6-20 karakter.",
    "payWayPlusC" : "Bonus Kanal",
    "fwtk" : "Persyaratan Layanan",
    "yszc" : "Kebijakan Privasi",
    "exchange" : "Tukar kode hadiah",
    "remember" : "Ingat Saya",
    "thirdInfo" : "Tentang Akun",
    "thirdInfoContent" : "Tautkan akun Anda di Pusat Pengguna dalam Game. Setelahnya, Anda dapat Log In menggunakan akun tautan.",
    "unLink" : "Metode ini belum dapat digunakan",
    "favour" : "Bookmark",
    "goStoreTip" : "Lanjut ke halaman pembayaran",
    "go" : "Pergi",
    "otherLogin" : "Metode Log In lainnya",
    "qrCodeTip" : "Pindai kode QR untuk mulai perjalanan!",
    "favourTip" : "Simpan ke Bookmark, mudah akses Game~",
    "share" : "Bagikan",
    "landscapeTip" : "Jalankan dengan mode Portrait",
    "leaveTip" : "Log Out dari Game?",
    "selectRole" : "Pilih karakter yang ingin Anda Top Up",
    "selectMoney" : "Pilih properti yang ingin dibeli",
    "seletGameInfoFirst" : "Pilih info Game",
    "lowerIE" : "Versi IE terlalu lama",
    "linkTermText" : "Saya menyetujui [Persyaratan Layanan] dan [Kebijakan Privasi] platform {mainHost}",
    "download" : "Unduh",
    "favourAndDownloadTip" : "Simpan halaman ke Bookmark atau unduh ke komputer &lt;br/&gt;",
    "payReward" : "Hadiah Top Up",
    "hasEqualReward" : "Double Bonus berlaku untuk kedua metode pembayaran",
    "payBtnText" : "Bayar",
    "storeHoaveReward" : "Bonus Top Up",
    "showMorePayWay" : "Metode lainnya",
    "needPaymentCount" : "Total Harga",
    "orderDetail" : "Rincian Order",
    "selectPayWayPlz" : "Pilih metode pembayaran",
    "countryCode" : "Kode negara",
    "deleteaccount_title1" : "Hapus Akun",
    "deleteaccount_title2" : "Permohonan hapus akun",
    "deleteaccount_step1_1" : "Akun Anda akan dibekukan selama 14 hari setelah dihapus. Setelah 14 hari, akun akan terhapus permanen. Anda tidak akan bisa Log In dengan Akun media sosial lainnya.",
    "deleteaccount_step1_2" : "Selama 14 hari, Anda masih bisa membatalkan penghapusan akun melalui tautan berikut:",
    "deleteaccount_step1_3" : "Setelah dihapus, Anda tidak akan bisa memulihkan data akun. Anda tidak akan mendapat kompensasi kerugian yang disebabkan penghapusan akun.",
    "deleteaccount_step1_4" : "Yakin ingin menghapus akun Anda?",
    "deleteaccount_step2_1" : "Yakin hapus akun dan semua data karakter Anda?",
    "deleteaccount_step2_2" : "Ketik \"Delete\" di kolom teks untuk menghapus.",
    "deleteaccount_step3" : "Akun Anda akan dihapus dalam 14 hari.",
    "accountrecovery_note" : "Tips:",
    "accountrecovery_tips" : "Penghapusan hanya bisa dibatalkan selama periode pembekuan 14 hari.",
    "accountrecovery_Submitted2" : "Permohonan pembatalan diterima. Akun Anda akan segera dikembalikan.",
    "accountrecovery_Failed" : "Gagal Mengirim",
    "accountrecovery_Failed_1" : "Akun dalam status normal, silakan Log In seperti biasa.",
    "accountrecovery_Failed_2" : "Informasi Karakter tidak ditemukan.",
    "accountrecovery_success" : "Akun berhasil dipulihkan",
    "account_normal" : "Status normal, akun tidak perlu pemulihan.",
    "account_unablerestore" : "Akun sudah terhapus. Tidak bisa dipulihkan.",
    "accountrecovery_roleHolder" : "Masukkan nama karakter",
    "accountrecovery_headerTitle" : "Batalkan penghapusan akun",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "Reparasi akun",
    "inputAccount" : "Masukkan nama akun yang ingin Anda pulihkan",
    "applyForAccountFix" : "Ajukan pemulihan akun",
    "nonEnterItem" : "Informasi yang harus dilengkapi: Tanggal Registrasi, Nomor Model, Nama Perangkat, No. KTP/Paspor, E-mail; Silakan diisi",
    "resetOT" : "Waktu habis, ulangi kirim tinjauan",
    "addOT" : "Waktu habis, kirim ulang data tambahan",
    "errorPwd" : "Password harus terdiri dari 6-20 karakter, menggunakan huruf, angka, dan simbol (\".\",\"_\",\"@\").",
    "verifyAccount" : "Info akun belum lengkap, periksa kembali",
    "selectRegisterTime" : "Pilih waktu registrasi.",
    "enterBindEmail" : "Masukkan E-mail yang sudah ditautkan.",
    "enterUsedPhoneType" : "Masukkan seri perangkat.",
    "enterIdfaGpid" : "Masukkan UDID perangkat.",
    "enterContactEmail" : "Format E-mail salah, masukkan kembali.",
    "confirmTermsPrivacy" : "Baca dan setujui Persyaratan Layanan dan Kebijakan Privasi.",
    "enterRechargeRemark" : "Masukkan catatan Top Up Anda.",
    "uploadImg" : "Pindai dan unggah foto KTP/Paspor Anda.",
    "selectIDType" : "Pilih jenis kartu identitas.",
    "enterIDNum" : "Masukkan No. KTP/Paspor",
    "enterIP" : "Masukkan alamat IP saat registrasi",
    "enterQueryNum" : "Masukan No.Tinjauan",
    "enterQueryPwd" : "Masukan Password Tinjauan",
    "errorQueryItem" : "Nomor atau Password Tinjauan salah, coba lagi.",
    "enterPassword" : "Masukkan Password baru",
    "enterPasswordAgain" : "Konfirmasi Password baru",
    "enterPasswordNonSame" : "Password tidak sama",
    "enterEmail" : "Masukkan alamat E-mail",
    "sendSuccess" : "E-mail berhasil terkirim",
    "enterCode" : "Silakan masukkan kode verifikasi",
    "errorCode" : "Kode verifikasi yang dimasukkan salah",
    "selectQuest" : "Silakan pilih pertanyaan keamanan",
    "enterAnswer" : "Silakan masukkan jawaban",
    "selectDifferQuest" : "Pilih 3 pertanyaan keamanan untuk dijawab",
    "addSuccess" : "Berhasil menambahkan data",
    "picFormt" : "Format gambar: JPG, PNG, atau GIF",
    "countdownBefore" : "Sisa waktu pengaturan ulang:",
    "countdownAfter" : "(Tautan akan berakhir pada pukul 00:00:00, kirim ulang permintaan pemulihan akun)",
    "uploadDone" : "Berhasil mengunggah",
    "uploadFail" : "Gagal mengunggah",
    "applySuccess" : "Permohonan berhasil",
    "applyFailed" : "Permohonan gagal",
    "resetQuestAlterFailed" : "Gagal mengubah pertanyaan keamanan",
    "resetQuestError" : "Data yang dimasukkan bermasalah",
    "resetQuestNone" : "Order tidak ditemukan",
    "resetQuestAltered" : "Pertanyaan keamanan sudah diubah",
    "illegalOperation" : "Proses ilegal",
    "queryNotExist" : "No.Tinjauan tidak tersedia",
    "queryPasswordError" : "No.Tinjauan bermasalah",
    "auditing" : "Dalam pemeriksaan",
    "notPass" : "Ditolak",
    "suppleInformation" : "Tambah data",
    "suppleInformationUnHandle" : "Data sudah ditambahkan, tunggu proses.",
    "suppleInformationTimeout" : "Waktu tambah data sudah berakhir.",
    "repairedAccountSuccess" : "Proses pemulihan akun selesai",
    "repairedAccountLost" : "Proses pemulihan sudah tidak berlaku",
    "loginStateNone" : "Belum Log In atau sesi sudah berakhir",
    "repairedAccountTimeout" : "Waktu pemulihan akun sudah berakhir",
    "changePasswordSucc" : "Password berhasil diubah",
    "emailSendFailed" : "E-mail gagal terkirim",
    "emailSendLimit" : "Pengiriman kode verifikasi sudah mencapai batas hari ini",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "Kode verifikasi E-mail sudah terkirim.",
    "alterSuccess" : "Berhasil diubah",
    "questionAlterSuccess" : "Berhasil mengubah pertanyaan keamanan",
    "username" : "Masukkan nama akun",
    "code" : "Silakan masukkan kode verifikasi",
    "selectServiceType" : "Pilih Jenis Layanan",
    "submitForm" : "Ajukan formulir untuk pemulihan akun",
    "apply" : "Ajukan",
    "reviewApplicationStatus" : "Tinjau status pemulihan",
    "instantReviewOfTheStatus" : "Cek langsung status pemulihan",
    "reviewStatus" : "Tinjau status",
    "backToLogin" : "Kembali ke Log In",
    "previous" : "Sebelumnya",
    "applyDesc" : "Lengkapi data agar kami dapat membantu Anda. Isi bagian yang ditandai *, ketik \"Tidak ada\" jika akun tidak memiliki data yang disebutkan.",
    "additionalServices" : "Layanan Tambahan",
    "resetSecurityEmail" : "Atur Ulang E-mail Keamanan",
    "resetSecurityQuest" : "Atur Ulang Pertanyaan Keamanan",
    "registrationDate" : "Waktu Registrasi",
    "month" : "Bulan",
    "year" : "Tahun",
    "emailBound" : "Tambahkan E-mail yang sudah ditautkan",
    "modelNumber" : "Tambahkan Seri Perangkat;",
    "deviceName" : "Tambahkan Seri Perangkat;",
    "provideRecharge" : "Mohon isi Catatan Top Up Anda secara detail, termasuk Waktu, Metode, Jumlah, No.Order, dan ID Transaksi untuk kami periksa.",
    "selectCountry" : "Pilih Wilayah",
    "passportID" : "KTP/Paspor",
    "upload" : "Unggah",
    "del" : "Hapus",
    "pleaseUpload" : "Pindai dan unggah foto KTP/Paspor Anda, maksimal 20MB",
    "uploadAgain" : "Unggah kembali",
    "enterDesc" : "Masukkan informasi yang dapat membuktikan kepemilikan akun",
    "contactEmail" : "E-mail",
    "applyNoteAttr" : "Peringatan:",
    "applyNoteDate" : "Masukkan alamat E-mail agar kami dapat mengirimkan hasil dari permohonan Anda.",
    "agree" : "Saya setuju",
    "UJOYTerms" : "Persyaratan Layanan UJOY",
    "privacy" : "Kebijakan Privasi",
    "reviewStatusOfAccountFix" : "Tinjau status pemulihan",
    "enterReviewID" : "Masukan No.Tinjauan",
    "enterReviewPwd" : "Masukan Password Tinjauan",
    "review" : "Tinjau",
    "reviewNoteAttr" : "Peringatan:",
    "reviewNoteData" : "Periksa E-mail apabila Anda lupa Nomor dan Password Tinjauan",
    "haveResetInfo" : "Anda sudah mengatur ulang Profil!",
    "resetProfile" : "Atur ulang Profil Anda",
    "desc" : "Selamat! Permohonan disetujui! Silakan atur ulang profil Anda.",
    "changePwd" : "Ubah Password",
    "resetPwd" : "Atur ulang Password",
    "reset" : "Ubah",
    "enterNewPwd" : "Masukkan Password baru",
    "confirmNewPwd" : "Konfirmasi Password baru",
    "successResetPwd" : "Berhasil mengatur Password baru",
    "bindSecurityEmail" : "Tautkan E-mail Keamanan",
    "resetPwdDesc" : "Segera atur ulang Password saat lupa Password atau akun Anda diretas",
    "bindCommon" : "Tautkan",
    "sendCommon" : "Kirim",
    "enterVcode" : "Masukkan kode verifkasi",
    "successResetEmail" : "Berhasil Atur Ulang Pertanyaan Keamanan",
    "resetQuest" : "Atur Ulang Pertanyaan Keamanan",
    "resetQuestDesc" : "Segera atur ulang Password saat lupa Password atau akun Anda diretas",
    "successResetQuest" : "Berhasil Atur Ulang Pertanyaan Keamanan",
    "hide" : "Sembunyikan",
    "addRegisterTime" : "Tambahkan Waktu Registrasi;",
    "modelNum" : "Tambahkan Nomor Model: IDFA/GPID",
    "registrationIP" : "Tambahkan alamat IP saat registrasi;",
    "addRechargeRecord" : "Tambahkan catatan Top Up;",
    "serviceReply" : "Balasan CS:",
    "addDataLimitTime" : "Batas waktu Tambah Data:",
    "addMoreInfo" : "Tambah Data Lainnya",
    "applicationSubmit" : "Permohonan berhasil terkirim",
    "underReviewStatus" : "Data Anda sedang kami periksa. Mohon tunggu respon dari kami dalam 1x24 jam. Cek status melalui metode berikut:",
    "reviewID" : "No.Tinjauan:",
    "reviePwd" : "Password Tinjauan:",
    "enterReviewIDNPwd" : "Masukkan Nomor dan Password Tinjauan untuk melihat status",
    "homepage" : "Beranda",
    "checkEmailAttr" : "Peringatan:",
    "checkEmailData" : "Periksa E-mail apabila Anda lupa Nomor dan Password Tinjauan",
    "underReview" : "Data sedang diverifikasi",
    "underReviewReply" : "Data sedang diverifikasi. Kami akan merespon Anda secepatnya. Terima kasih sudah bersedia menunggu!",
    "failed" : "Permohonan belum disetujui",
    "reason" : "Alasan: ### Sehingga permohonan belum dapat disetujui, silakan kirimkan informasi yang benar, staf kami akan membantu. Terima kasih atas kerja samanya!",
    "underReviewAdd" : "Data Anda sedang diverifikasi. Sebagian data tidak lengkap atau tidak sama. Silakan lengkapi agar dapat kami konfirmasi kembali!",
    "addInfoRequired" : "Data yang perlu ditambahkan:",
    "dateForAddInfo" : "Batas waktu Tambah Data:",
    "addInfo" : "Tambah data",
    "addInfoSubmit" : "Data sudah terkirim! Mohon menunggu!",
    "hasBeenRepaired" : "Proses pemulihan akun selesai",
    "opExpired" : "Proses pemulihan sudah tidak berlaku",
    "approved" : "Permohonan disetujui",
    "haveSubmitted" : "Anda sudah menambahkan data",
    "sessionExpired" : "Anda belum Log In atau sesi sudah berakhir",
    "submitted" : "Penambahan berhasil",
    "addItemRegisterDate" : "Lengkapi E-mail tautan;",
    "addItemDeviceNumber" : "Lengkapi UDID perangkat;",
    "reasonItemPwd" : "No.KTP/Paspor tidak sesuai;",
    "addItemIDPhoto" : "Lengkapi Foto ID;",
    "idfaTitle" : "Cara menemukan IDFA dan ID untuk perangkat Android",
    "idfaSubTitle1" : "1. Cara menemukan IDFA (iOS)",
    "idfaSubTitle1Desc1" : "1. Unduh 【<em>MyIDFA</em>】dari Appstore.",
    "idfaSubTitle1Desc2" : "2. Instal lalu pilih <em>APP</em> untuk melihat kode <em>IDFA</em> Anda.",
    "idfaSubTitle2" : "2. Cara menemukan ID Google",
    "idfaSubTitle2Desc1" : "1. Buka fitur 【<em>Setelan</em>】;",
    "idfaSubTitle2Desc2" : "2. Cari 【<em>Akun</em>】 atau 【<em>Akun dan Sinkronisasi</em>】, klik 【<em>Google</em>】.",
    "idfaSubTitle2Desc3" : "3. Klik 【<em>Iklan</em>】 untuk melihat <em>ID</em>Anda (seperti di gambar).",
    "uploadIDCard" : "Pindai dan unggah foto KTP/Paspor Anda, maksimal 20MB",
    "uploadTipsBefore" : "Ukuran foto tidak lebih dari",
    "uploadTipsAfter" : "M",
    "submitError" : "Terjadi eror karena No.KTP/Paspor belum diisi atau info akun salah",
    "applyLimitError" : "Melebihi kuota permohonan harian",
    "applyDisabled" : "Permohonan hanya dapat dikirim sekali setiap 10 menit.",
    "inputDataError" : "Data belum lengkap",
    "dataException" : "Data eror",
    "picSizeLimit" : "Gambar maksimal berukuran 5MB",
    "picTypeLimit" : "Unggah gambar dengan format JPG, PNG, GIF",
    "picNull" : "Gambar kosong",
    "alteredPassword" : "Password sudah diubah",
    "inputError" : "Gagal memasukkan",
    "pwdChangefailed" : "Gagal mengubah Password",
    "sendEmailCodeDisabled" : "Tunggu beberapa saat untuk mengirim kode verifikasi",
    "alteredEmail" : "E-mail sudah diubah",
    "inputEmailError" : "E-mail yang dimasukkan bermasalah",
    "operationFailed" : "Pengoperasian gagal",
    "codeNull" : "Anda belum memasukkan kode verifikasi",
    "findPwd" : "Lupa Password",
    "findAccountAndPwd" : "Lupa Akun/Password",
    "usualDeviceNum" : "Nomor Model: IDFA/GPID",
    "usualPhoneNum" : "Seri Perangkat",
    "registerTimeError" : "Waktu Registrasi tidak sesuai;",
    "bindEMailError" : "E-mail tautan tidak sesuai;",
    "rechargeRecordError" : "Catatan Top Up tidak sesuai;",
    "registerIPError" : "Alamat IP Registrasi tidak sesuai;",
    "deviceNumError" : "UDID Perangkat tidak sesuai;",
    "deviceModelError" : "Seri Perangkat tidak sesuai;",
    "confirmTerms" : "Silakan menyetujui Persyaratan Layanan",
    "applyFixAccount" : "Jika metode di atas tidak berhasil, silakan ajukan <span>pemulihan akun</span>",
    "findPwdByFixAccount" : "Atur E-mail keamanan untuk pemulihan akun dan Password.",
    "connectFail" : "Layanan Google terputus, silakan coba lagi",
    "h5_favour_has_gift" : "Simpan ke Bookmark peramban~ Anda sudah pernah mendapatkan hadiah~",
    "h5_favour_get_gift" : "Simpan ke Bookmark peramban~ Hadiah sudah dikirimkan ke E=mail Anda~",
    "h5_get_gift_fault" : "Klaim gagal. Coba lagi nanti atau hubungi CS jika masih bermasalah.",
    "h5_favour_please_select" : "Pilih Server/Karakter",
    "h5_favour_login_get" : "Masuk dan simpan ke Boomark peramban untuk klaim hadiah~",
    "h5_favour_tip" : "Simpan ke Bookmark peramban~",
    "h5_favour_select_serve" : "Pilih Server",
    "h5_favour_select_role" : "Pilih karakter",
    "store_product_paytype_error" : "Ganti metode pembayaran untuk membeli item ini.",
    "SwitchWithThirdWay" : "Ganti ke \${type}",
    "moreGame" : "Game lainnya",
    "serviceTitle" : "Layanan",
    "h5_download_login" : "Masuk lebih dahulu dan unduh untuk klaim hadiah~",
    "h5_download_tips" : "Please start the game from the client.",
    "h5_download_repeat_get" : "Simpan ke desktop, mudah akses Game~ Anda sudah pernah mendapatkan hadiah~",
    "h5_download_succ" : "Simpan ke desktop, mudah akses Game~ Hadiah sudah dikirimkan ke E=mail Anda~",
    "h5_download_repeat_role" : "Karakter sudah ditautkan",
    "currentLoginAccount" : "Akun saat ini:",
    "fb_canvas_fullscreen" : "Layar penuh",
    "fb_canvas_website" : "Situs resmi",
    "fb_canvas_like_share" : "Bagikan",
    "fb_canvas_service" : "CS",
    "fb_canvas_login_fail" : "Gagal Log In",
    "fb_canvas_pay_return" : "Anda sudah membatalkan transaksi",
    "fb_canvas_root_tip" : "Silakan otorisasi ke Facebook untuk Log In",
    "h5_popup_title" : "Cara Pembayaran",
    "h5_popup_submit" : "Bayar",
    "h5_popup_last_used" : "Terakhir digunakan",
    "h5_popup_quit_tips" : "Yakin batalkan pembayaran?",
    "h5_popup_quit_check" : "Ya",
    "h5_popup_quit_cancel" : "Tidak",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Info produk belum tersedia, Refresh halaman.",
    "h5_popup_server_empty" : "Daftar Server belum tersedia, Refresh halaman.",
    "aboutRelevanceAccount" : "Akun terhubung",
    "selectLoginType" : "Pilih metode Log In",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Ingat Saya selama 14 hari",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : ", batal permintaan hapus akun. Batalkan sekarang?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "Paket",
    "h5_award_popup_type" : "Hadiah",
    "h5_award_popup_content" : "Item",
    "h5_award_popup_code" : "Kode Paket",
    "h5_favour_gift_name" : "Paket Favorit",
    "h5_download_gift_name" : "Unduh Paket",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "Selamat, Anda mendapat Kode Paket!",
    "h5_exchange_info_title" : "Penukaran Hadiah",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "Paket hanya dapat diunduh 1x per akun",
    "h5_check_gift" : "Periksa Hadiah",
    "account_delete_scdqzh" : "Yakin hapus akun dan semua data karakter Anda?",
    "account_delete_fwq" : "Server",
    "account_delete_zhm" : "Karakter",
    "account_delete_jshflj" : "Tautan pemulihan karakter",
    "account_delete_qzyzmdxx" : "(Perhatikan penggunaan huruf kapital)",
    "account_delete_jtbcysxx" : "Tangkap layar dan simpan informasi di atas untuk pemulihan akun!!!!",
    "deleteaccount_step3_2" : "Setelah 14 hari, Akun Anda akan terhapus dan tidak dapat dipulihkan kembali. Anda akan kehilangan seluruh data yang tersimpan.\\\\n\\\\nAnda tetap dapat mengaksesnya 14 hari setelah pengajuan.",
    "h5_guest_login" : "Tamu",
    "h5_click_copy" : "Salin",
    "questionnaire_btn" : "Kuisioner",
    "h5_header_store_text" : "Top Up",
    "h5_header_home_text" : "Laman",
    "h5_check_gift_list_text" : "Cek Hadiah",
    "yourServer" : "Server Anda",
    "allServer" : "Semua Server",
    "h5_header_screen" : "Layar penuh",
    "h5_verticalTip" : "Jalankan dengan mode Landscape",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "UID Akun",
    "webStoreUidTips" : "Konfirmasi informasi akun Anda",
    "webStoreUidGuide" : "Bagaimana cara memperoleh UID?",
    "webStoreUidInputt" : "Masukkan UID",
    "feedbackTips" : "",
    "recentPlay" : "Riwayat",
    "moreGames" : "Lainnya",
    "previousSelect" : "Sebelumnya",
    "payAgainBtn" : "Top Up lagi",
    "packageTypeName" : "Paket",
    "coinTypeName" : "Top Up",
    "cardTypeName" : "Kartu Bulanan",
    "orderNormal" : "Bawaan",
    "orderPriceUp" : "Harga↑",
    "orderPriceDown" : "Harga↓",
    "returnSelectRole" : "Kembali",
    "jiamaInfo" : "Skema Bonus:</br>Bonus Pembayaran = Nilai pembayaran * Rate mata uang Game * Rate bonus</br>*Ket: Event Top Up atau VIP EXP tidak dihitung ke nilai bonus</br>*Nilai pembayaran dihitung dalam USD untuk Game yang dirilis internasional. Hubungi CS jika ada pertanyaan.",
    "lastSelectTag" : "Pilihan sebelumnya",
    "onestore_subscribe_manage" : "Kelola langganan",
    "onestore_subscribe_entrance" : "Kelola langganan OneStore",
    "onestore_subscribe_has_expire" : "Kedaluwarsa",
    "onestore_subscribe_expire_time" : "Kedaluwarsa: \${day}/\${month}/\${year}",
    "onestore_subscribe_privacy" : "Tentang Langganan da Privasi",
    "onestore_subscribe_cancel_subscribe" : "Batal berlangganan",
    "onestore_subscribe_info_title" : "Info berlangganan",
    "onestore_subscribe_option_title" : "Pilihan",
    "onestore_subscribe_do_not_subscribe" : "Karakter saat ini belum berlangganan",
    "onestore_subscribe_get_role_fail" : "Gagal mendapat info langganan. Masuk lagi dari dalam Game.",
    "onestore_subscribe_later" : "Ke depannya",
    "onestore_subscribe_confirm" : "Konfirmasi",
    "onestore_subscribe_confirm_cancel" : "Konfirmasi batal berlangganan",
    "onestore_subscribe_popup_tip" : "Jika yakin batal berlangganan, Anda masih dapat mengakses layanan hingga \${day}/\${month}/ \${year}.",
    "onestore_subscribe_detail_tip" : "Layanan akan diperpanjang otomatis pada \${day}/\${month}/ \${year} (Biaya: \${prices}/bln). Langganan bisa dibatalkan 1 hari sebelum kedaluwarsa.",
    "onestore_subscribe_expired_tip" : "Anda dapat memperbarui berlangganan di Mall/Toko dalam Game.",
    "onestore_subscribe_goon_sub" : "Diperpanjang pada \${day}/\${month}/ \${year}",
    "onestore_subscribe_has_cancel_tip1" : "Langganan sudah dibatalkan, Anda masih dapat mengakses layanan hingga \${day}/\${month}/ \${year}.",
    "onestore_subscribe_has_cancel_tip2" : "Hubungi Mall/Toko dalam Game jika Anda ingin berlangganan kembali",
    "onestore_subscribe_cancel_fail" : "Langganan gagal dibatalkan. Coba lagi.",
    "onestore_subscribe_cancel_fail_title" : "Batal berlangganan",
    "apple_deleteaccount" : "Hapus akun",
    "apple_deleteaccount_title" : "Permohonan hapus akun",
    "apple_deleteaccount_step1_1" : "Baca S&K berikut dengan seksama:",
    "apple_deleteaccount_step1_2" : "Akun Anda akan dibekukan selama 14 hari setelah dihapus.",
    "apple_deleteaccount_step1_3" : "Setelah 14 hari, akun akan <span class=\"highlight\">terhapus permanen</span>. Anda tidak akan bisa Log In dengan Akun ini lagi, semua data akan terhapus dan tidak dapat dipulihkan.",
    "apple_deleteaccount_step1_4" : "Hubungi tim CS untuk menghapus tautan media sosial dari Akun sebelum dihapus. Jika tidak, Anda tidak akan bisa menautkan kembali akun ke media sosial Anda untuk Log In.",
    "apple_deleteaccount_step1_5" : "<span class=\"highlight\">Sebelum menghapus, hubungi CS untuk pengembalian dana</span>, pastikan Anda sudah memproses semua aset dalam Game.",
    "apple_deleteaccount_step1_6" : "Selama 14 hari, Anda masih bisa membatalkan penghapusan akun melalui tautan berikut: (Salin dan simpan tautan)",
    "apple_deleteaccount_step2_1" : "Apakah Anda sudah memproses aset Game Anda? Jika belum, hubungi CS untuk diproses sebelum mengajukan hapus akun.",
    "apple_deleteaccount_step2_2" : "Simpan informasi Server dan Karakter Anda sebagai syarat pemulihan akun:",
    "apple_deleteaccount_step2_3" : "Ketik \"Delete\" di kolom teks untuk menghapus.",
    "apple_deleteaccount_step3_1" : "Permohonan hapus akun sudah terkirim. Berikut akun yang akan dibekukan:",
    "apple_deleteaccount_step3_2" : "Anda dapat membatalkan penghapusan dalam 14 hari. Setelahnya, akun akan terhapus permanen.",
    "apple_deleteaccount_step3_3" : "Anda dapat membatalkan penghapusan melalui tautan berikut dalam 14 hari.",
    "apple_deleteaccount_step4_1" : "Akun lama Anda sudah dihapus. Gunakan akun baru untuk Log In.",
    "apple_deleteaccount_agree" : "Saya sudah membaca dan menyetujui S&K",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Karakter",
    "copyLink" : "Salin tautan",
    "copyTextAndImg" : "Salin atau tangkap layar",
    "copyLinkAndRoleInfo" : "Salin tautan dan karakter",
    "hasCopy" : "Disalin ke papan klip",
    "quickcard_tips" : "Detail kartu kredit sudah terenkripsi dan dilindungi World Pay. Info berikut hanya demi kenyamanan Top Up.",
    "quickcard_use_new_card" : "Kartu kredit baru",
    "edit" : "Edit",
    "save" : "Simpan",
    "quickcard_confirm_delete" : "Hapus?",
    "quickcard_popup_tip" : "Pilih opsi \"Kartu Kredit Baru\" jika Anda ingin menggunakan kartu ini kembali setelah dihapus.",
    "quickcard_result_tip_one" : "Data kartu Anda (**** **** **** 1234) kami simpan secara terenkripsi jika Anda memilih menyimpan data kartu pada halaman sebelumnya.",
    "quickcard_result_tip_two" : "Anda tidak perlu repot memasukkan data kartu untuk pembelian selanjutnya karena sudah tersimpan secara terenkripsi.",
    "quickcard_learn_more" : "Pelajari lagi 》",
    "quickcard_info_title" : "Pernyataan Penyimpanan Kredensial",
    "quickcard_info_tip_one" : "Demi melindungi keamanan data pengguna, Visa dan Mastercard mengadopsi teknologi \"Penyimpanan Kredensial\" yang mengatur penyimpanan kredensial dan transaksi terkait.",
    "quickcard_info_tip_two" : "Saat berbelanja di situs web kami, data kartu Anda (1234 **** **** 1234) akan kami simpan secara terenkripsi. Kami akan menyimpan data tersebut selama 4 tahun, dan akan memperbarui Perjanjian serta Kebijakan Privasi di situs web kami jika terdapat perubahan. Data kartu hanya disimpan untuk memudahkan Anda berbelanja tanpa harus terus memasukkan nomor kartu.",
    "search_product" : "Cari item",
    "search_price" : "Cari harga",
    "price" : "Harga",
    "product_no_found" : "Maaf, tidak ada item yang cocok",
    "price_no_found" : "Maat, tidak ada harga yang cocok",
    "search_no_found" : "Maat, tidak ada item/harga yang cocok",
    "product" : "Item",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "Berlangganan",
    "useDoubleSend" : "Gunakan kupon Paket Duo?",
    "doubleSendInfo" : "Anda menggunakan kupon Paket Duo, beberapa item yang Anda beli akan berlipat ganda (ditampilkan di bawah)!",
    "storeRoleTitle" : "Silakan Pilih Karakter",
    "storeSocialLogin" : "Log in dengan akun SNS",
    "storeAccountIdLogin" : "Log in dengan ID Akun",
    "storeInputId" : "Silakan masukkan ID Akun",
    "storeSearch" : "Tinjau",
    "storeSelectProductTitle" : "Pilih item yang ingin dibeli",
    "storeInputNameSearch" : "Cari dengan nama item",
    "storeInputPriceSearch" : "Cari dengan harga item",
    "storeNoFindProduct" : "Item tidak ditemukan, ulangi pencarian.",
    "storePriceUp" : "Harga↑",
    "storePriceDown" : "Harga↓",
    "storeLookDetail" : "Rincian",
    "storeChangeProduct" : "Ubah item",
    "storeWelcome" : "Selamat datang",
    "storeLookMore" : "Lebih banyak",
    "storeHasSelect" : "Item terpilih",
    "storeTotal" : "Total",
    "storeExtra" : "Bonus",
    "storeProductDetail" : "Rincian",
    "storeUidGuideStep1" : "Klik Setelan - Lainnya - Akun",
    "storeUidGuideStep2" : "Masukkan ID Akun untuk Top Up",
    "storeSelectAndLook" : "Pilih karakter untuk melihat item",
    "storeSwitchWay" : "Ganti metode Log In",
    "type1" : "Promo Harian",
    "type2" : "Hero",
    "type3" : "Battle Gear",
    "type4" : "",
    "type5" : "Chip",
    "type6" : "Nova",
    "type7" : "Sumber Daya",
    "type8" : "Percepat Pembangunan",
    "type9" : "Item Langka",
    "type10" : "Aliansi",
    "type11" : "Diamond",
    "type12" : "Modul",
    "type13" : "Cube",
    "type14" : "",
    "type15" : "Nanoweapon",
    "type16" : "Hadiah Utama",
    "type17" : "",
    "type9999" : "Penawaran Terbatas",
    "type10000" : "Pusat Hadiah",
    "type10001" : "Event Festival",
    "typeother" : "Produk Lainnya",
    "switchChar" : "Ganti Karakter",
    "howToFindUid" : "Bagaimana cara menemukan ID Akun saya?",
    "choosePayWay" : "Pilih Metode Pembayaran",
    "new_apple_deleteaccount_stepsub_title" : "Batalkan Perpanjangan Otomatis",
    "new_apple_deleteaccount_stepsub_1" : "Akun Anda memiliki perpanjangan langganan otomatis. Silakan batalkan perpanjangan otomatis sebelum hapus akun agar tidak terjadi pembelian yang tidak diinginkan.",
    "new_apple_deleteaccount_stepsub_2" : "Batalkan Perpanjangan Otomatis",
    "new_apple_deleteaccount_stepsub_later" : "Tunda",
    "new_apple_deleteaccount_stepsub_now" : "Sekarang",
    "new_apple_deleteaccount_title" : "Permohonan hapus akun",
    "new_apple_deleteaccount_step1_1" : "Baca S&K berikut dengan seksama:",
    "new_apple_deleteaccount_step1_2" : "Akun akan <span class=\"highlight\">terhapus permanen</span> setelah Anda pilih hapus. Anda TIDAK akan bisa Log In dengan Akun ini lagi, semua data akan terhapus dan tidak dapat dipulihkan.",
    "new_apple_deleteaccount_step1_3" : "Hubungi tim CS untuk menghapus tautan media sosial dari Akun sebelum dihapus. Jika tidak, Anda tidak akan bisa menautkan kembali akun ke media sosial Anda untuk Log In.",
    "new_apple_deleteaccount_step1_4" : "<span class=\\highlight\\>Sebelum menghapus, hubungi CS untuk pengembalian dana</span>, pastikan Anda sudah memproses semua aset dalam Game.",
    "new_apple_deleteaccount_step2_1" : "Apakah Anda sudah memproses aset Game Anda? Jika belum, hubungi CS untuk diproses sebelum mengajukan hapus akun.",
    "new_apple_deleteaccount_step2_2" : "Ketik \"Delete\" di kolom teks untuk menghapus. Akun tidak akan dapat dipulihkan setelah permohonan terkirim.",
    "new_apple_deleteaccount_step2_3" : "Ketik \"Delete\" di kolom teks untuk menghapus.",
    "new_apple_deleteaccount_step3_1" : "Permohonan hapus akun telah terkirim. Akun berikut beserta data pengguna telah terhapus dan tidak dapat dipulihkan:",
    "new_apple_deleteaccount_step3_2" : "Silakan buat akun baru untuk Log In.",
    "new_apple_deleteaccount_step4_1" : "Akun lama Anda sudah dihapus. Gunakan akun baru untuk Log In.",
    "currencyTypeName" : "Mata Uang",
    "has_select_product" : "Item terpilih:",
    "n_product" : "\${n} Item",
    "look_detail_product" : "Lihat Semua",
    "limit_buy_product" : "Maksimal pembelian Item ini: \${n}",
    "limit_order" : "Maksimal pembelian \${n} Item per transaksi.",
    "limit_order_remove_tip" : "Anda sudah mencapai batas pembelian untuk beberapa Item di keranjang. Hapus Item?",
    "paytype_limit" : "Metode pembayaran tidak dapat digunakan untuk sebagian Item, pilih metode lainnya atau beli secara terpisah.",
    "check_remove_cart" : "Hapus dari keranjang?",
    "remove_cart" : "Hapus",
    "confirm_product" : "Konfirmasi",
    "select_paytype" : "Pilih Metode Pembayaran",
    "cart_is_empty_tip" : "Keranjang kosong. Silakan pilih Item.",
    "thirty_tip" : "Hubungi CS jika pembelian Anda gagal dalam 30 menit.",
    "total_n_product" : "Item x\${n}",
    "look_detail_of_cart" : "Rincian",
    "order_detail" : "Daftar Top Up Item",
    "total_detail" : "Jumlah:",
    "add_to_cart" : "Tambah ke Keranjang",
    "back_to_select" : "Kembali",
    "fail_and_later" : "Info Item bermasalah. Silakan coba lagi.",
    "nextStep" : "NEXT",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Visit \nWebsite",
    "visitorLogin" : "Guest",
    "tokenLogin" : "OTP",
    "fbLogin" : "log in with Facebook",
    "googleLogin" : "Log in with Google",
    "twitterLogin" : "Log in with Twitter",
    "vkLogin" : "Log in with VK",
    "agreementTextStart" : "By logging into the game, you confirm that you have read and agree to the Terms of Service and Privacy Policy.",
    "userCenter" : "User Center",
    "welcomeBack" : "Welcome Back",
    "continueGame" : "START",
    "officialPay" : "Top-Up Center",
    "changeAccount" : "Switch Account",
    "back" : "Back",
    "tokenKey" : "OTP",
    "inputUid" : "Enter your UID",
    "inputToken" : "Enter your OTP",
    "inputCkCode" : "Type the text",
    "enterGame" : "START",
    "tokenTip" : "Protect Your Account With OTP Verification",
    "howToGetToken" : "How to get my one-time password?",
    "getStep1" : "Step 1: Go to Settings > Account > User Center",
    "getStep2" : "Step 2: Tap OTP",
    "getStep3" : "Step 3: Copy and enter your UID and one-time password",
    "copy" : "Copy",
    "lastRefresh" : "Refreshes in:",
    "second" : "s",
    "immediatelyRefresh" : "Refresh Now",
    "frequently" : "Operation too frequent. Please try again later.",
    "loginFail" : "Login failed. Incorrect password.",
    "tokenIntro" : "About One-Time Password (OTP)",
    "tokenIntro1" : "1. One-time passwords expire in 120 seconds. Use them wisely to keep your account safe and secure.",
    "tokenIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "nextStep1" : "NEXT",
    "couponCanUse" : "Kupon valid",
    "couponCanNotUse" : "Kupon tidak valid",
    "couponHasNoCoupon" : "Tidak ada Kupon",
    "couponUseTip" : "*Hanya bisa menggunakan 1 lembar di setiap pesanan",
    "couponValidTime" : "Masa berlaku",
    "couponFuilCanUse" : "Bisa digunakan setelah memenuhi \${price} \${currency}",
    "couponNoLimit" : "Tidak ada syarat penggunaan",
    "couponAllProductCanUse" : "Bisa digunakan semua item",
    "couponPartProductCanUse" : "Bisa digunakan sebagian item",
    "couponPartPaytypeCanUse" : "Bisa digunakan sebagian Kanal Pembayaran",
    "couponOnlyCoinCanUse" : "Hanya bisa digunakan untuk item mata uang Game",
    "couponOnlyDiamondCanUse" : "Hanya bisa digunakan untuk item Diamond",
    "couponOnlyPackageCanUse" : "Hanya bisa digunakan untuk item Paket",
    "couponOnlySubCanUse" : "Hanya bisa digunakan untuk item Berlangganan",
    "couponOnlyDaibiCanUse" : "Hanya bisa digunakan untuk item Koin Gold",
    "couponMaxDiscount" : "Max diskon \${price} \${currency}",
    "couponHasUsed" : "Sudah digunakan",
    "couponReductionType" : "Kupon Minimal Belanja",
    "couponDiscountType" : "Kupon Diskon",
    "couponUseNow" : "Gunakan Langsung",
    "couponHasNoSelect" : "Belum memilih Kupon",
    "couponHasSelectQuan" : "Terpilih",
    "couponSubmitTip" : "*Konsumsi kupon setelah menyerahkan pesanan",
    "couponCanUseQuan" : "Kupon valid",
    "couponOrderTotal" : "Harga Pesanan",
    "couponHasDiscount" : "Diskon",
    "couponPayTotal" : "Total Harga",
    "couponCancel" : "Batal",
    "couponConfirm" : "Konfirmasi",
    "uidLoginName" : "Log in with OTP",
    "uidToken" : "OTP",
    "uidInputUid" : "Enter your UID",
    "uidInputToken" : "Enter your OTP",
    "uidInputCode" : "Type the text",
    "uidTipTitle" : "Protect Your Account With OTP Verification",
    "uidTipHowToGet" : "How to get my one-time password?",
    "uidTipStep1" : "Step 1: Go to Settings > Account > User Center",
    "uidTipStep2" : "Step 2: Tap OTP",
    "uidTipstep3" : "Step 3: Copy and enter your UID and one-time password",
    "uidTipIntro1" : "1. One-time passwords expire in 60 seconds. Use them wisely to keep your account safe and secure.",
    "uidTipIntro2" : "2. Staff won\'t ask for your one-time password. Please never share or give out your password.",
    "couponMyQuan" : "Kupon aku",
    "couponSelectPaytypeTip" : "Pastikan informasi diskon setelah memilih kanal pembayaran",
    "couponSelectCouponTip" : "Cek harga diskon setelah pilih kupon",
    "couponValidQuanTip" : "(\${num} lembar Kupon tersedia)",
    "couponLookCart" : "Cek Keranjang",
    "couponUnfoldCart" : "Simpan Keranjang",
    "couponCoupon" : "Kupon",
    "couponNoUse" : "Belum digunakan",
    "couponSelect" : "Pilih Kupon",
    "couponSureUse" : "Konfirmasi",
    "couponReturn" : "Kembali",
    "couponInvalidTime" : "Waktu Kedaluwarsa",
    "couponBuyNow" : "Buy Now",
    "couponAllType" : "all",
    "ztmslgType1" : "Promo Harian",
    "ztmslgType2" : "Hero",
    "ztmslgType3" : "Battle Gear",
    "ztmslgType4" : "",
    "ztmslgType5" : "Chip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Sumber Daya",
    "ztmslgType8" : "Percepat Pembangunan",
    "ztmslgType9" : "Item Langka",
    "ztmslgType10" : "Aliansi",
    "ztmslgType11" : "Diamond",
    "ztmslgType12" : "Modul",
    "ztmslgType13" : "Cube",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nanoweapon",
    "ztmslgType16" : "Hadiah Utama",
    "ztmslgType17" : "Crystal Core",
    "ztmslgType9999" : "Penawaran Terbatas",
    "ztmslgType10000" : "Pusat Hadiah",
    "ztmslgType10001" : "Event Festival",
    "ztmslgTypeother" : "Lainnya",
    "antslgType1" : "Daily Sale",
    "antslgType2" : "Specialized Ant",
    "antslgType3" : "Gear",
    "antslgType5" : "Gene",
    "antslgType6" : "Snail",
    "antslgType7" : "Resources",
    "antslgType8" : "Build & Research",
    "antslgType9" : "Rare Items",
    "antslgType10" : "Alliance",
    "antslgType11" : "Diamond",
    "antslgType12" : "Cell",
    "antslgType13" : "Totem",
    "antslgType9999" : "Limited Offer",
    "antslgTypeother" : "other",
    "typeall" : "Semua Produk",
    "vipHead" : "Poin VIP",
    "vipHead213": "Pusat Anggota",
    "vipTitle" : "Event poin VIP",
    "nowLevel" : "Level VIP:",
    "myVipScore" : "Poinku:",
    "nextLevelNeed" : "(Masih butuh \${num} poin untuk VIP \${level})",
    "ruleTitle" : "Aturan Event:",
    "ztmslgVipRule1" : "1. Waktu Event: 22/09/2022 00:00 (UTC)",
    "ztmslgVipRule2" : "2. Partisipasi game:  Puzzles & Survival",
    "ztmslgVipRule3" : "Hanya bisa klaim 1x untuk setiap hadiah Event. Silakan klaim tepat waktu.",
    "ztmslgVipRule4" : "3. Event “Bonus Kupon Via Login”: Saat login ke halaman Top Up untuk pertama kalinya, bisa klaim Kupon 15% OFF.",
    "ztmslgVipRule5" : "4. Event “Poin VIP”: Jika poin pembelian item mencapai level relevan di halaman pembayaran official, maka akan mendapat kupon level dan kupon eksklusif mingguan",
    "ztmslgVipRule6" : "5. Silakan cek rasio setiap mata uang di catatan 1, kurang dari 1 poin tidak dihitung",
    "ztmslgVipRule7" : "6. Jika pesanan menggunakan kupon, poin akan dikalkulasi berdasarkan pembayaran yang sebenarnya",
    "ztmslgVipRule8" : "7. Masa berlaku poin adalah 365 hari. Level VIP berubah sesuai poin yang berlaku di saat ini",
    "ztmslgVipRule9" : "8. Jika mencapai level VIP, bisa langsung klaim kupon perdana & kupon mingguan level baru. Kupon mingguan selanjutnya refresh setiap Sabtu jam 00:00 (UTC+0)",
    "ztmslgVipRule10" : "9. Perlu login untuk klaim kupon mingguan. Jika terlewat, tidak ada pengiriman ulang. Hadiah kupon akan diperbarui secara berkala",
    "ztmslgVipRule11" : "10. Jenis mata uang kupon didasarkan pada jenis mata uang pesanan Top up terakhir Anda. Silakan hubungi CS jika perlu tukar jenis mata uang",
    "ztmslgVipRule12" : "11. Aturan tingkat VIP dan kupon diskon hadiah adalah sebagai berikut:",
    "ztmslgVipRule13" : "12. Hak interpretasi akhir adalah milik tim operasional  Puzzles & survival .",
    "vipLevel" : "Level VIP",
    "vipCondition" : "Mencapai syarat poin",
    "firstSend" : "Pencapaian perdana mendapat bonus",
    "weeklySend" : "Kupon benefit mingguan",
    "lastAllCoupon" : "Semua kupon tingkat sebelumnya",
    "besides" : "Catatan:",
    "couponRatio" : "Rasio poin VIP setiap mata uang",
    "backToPay" : "Kembali Top up`",
    "quanGift" : "Benefit kupon",
    "quanGiftTips" : "Anda punya sejumlah kupon baru. Silakan terima",
    "antslgVipRule1": "Karena ganti fitur baru, event “Poin VIP” akan segera dihapus.",
    "antslgVipRule2": "Harap Anda segera gunakan Kupon dari “Poin VIP” agar tidak melewati masa berlaku Kupon.",
    "antslgVipRule3": "Waktu hapus: 28/9/2024 00:00:00 (UTC)",
    "antslgVipRule4": "Setelah event dihapus, Anda bisa menuju ke Pusat Anggota untuk mencoba lebih banyak benefit.",
    "antslgVipRule5": "Selesaikan misi untuk mendapatkan poin, gunakan poin bisa menukar kupon, item game, dan hadiah lainnya! Ada juga benefit anggota eksklusif, undian poin, dan event benefit lainnya",
    "antslgVipRule6": "Silakan nantikan.",
    "dzgVipRule0" : "1. Waktu Event: 27/09/2022 00:00 (UTC)",
    "dzgVipRule1" : "1. Partisipasi game:  \${gameName}",
    "dzgVipRule2" : "Hanya bisa klaim 1x untuk setiap hadiah Event. Silakan klaim tepat waktu.",
    "dzgVipRule3" : "2. Event “Bonus Kupon Via Login”: Saat login ke halaman Top Up untuk pertama kalinya, bisa klaim Kupon 15% OFF.",
    "dzgVipRule4" : "3. Event “Poin VIP”: Jika poin pembelian item mencapai level relevan di halaman pembayaran official, maka akan mendapat kupon level dan kupon eksklusif mingguan",
    "dzgVipRule5" : "4. Silakan cek rasio setiap mata uang di catatan 1, kurang dari 1 poin tidak dihitung",
    "dzgVipRule6" : "5. Jika pesanan menggunakan kupon, poin akan dikalkulasi berdasarkan pembayaran yang sebenarnya",
    "dzgVipRule7" : "6. Masa berlaku poin adalah 365 hari. Level VIP berubah sesuai poin yang berlaku di saat ini",
    "dzgVipRule8" : "7. Jika mencapai level VIP, bisa langsung klaim kupon perdana & kupon mingguan level baru. Kupon mingguan selanjutnya refresh setiap Sabtu jam 00:00 (UTC+0)",
    "dzgVipRule9" : "8. Perlu login untuk klaim kupon mingguan. Jika terlewat, tidak ada pengiriman ulang. Hadiah kupon akan diperbarui secara berkala",
    "dzgVipRule10" : "9. Jenis mata uang kupon didasarkan pada jenis mata uang pesanan Top up terakhir Anda. Silakan hubungi CS jika perlu tukar jenis mata uang",
    "dzgVipRule11" : "10. Aturan tingkat VIP dan kupon diskon hadiah adalah sebagai berikut:",
    "dzgVipRule12" : "11. Hak interpretasi akhir adalah milik tim operasional  \${gameName} .",
    "213dzgVipRule1" : "Karena ganti fitur baru, event “Poin VIP” akan segera dihapus.",
    "213dzgVipRule2" : "Harap Anda segera gunakan Kupon dari “Poin VIP” agar tidak melewati masa berlaku Kupon.",
    "213dzgVipRule3" : "Waktu hapus: 19/8/2024 08:00:00 (UTC)",
    "213dzgVipRule4" : "Setelah event dihapus, Anda bisa menuju ke Pusat Anggota untuk mencoba lebih banyak benefit.",
    "213dzgVipRule5" : "Selesaikan misi untuk mendapatkan poin, gunakan poin bisa menukar kupon, item game, dan hadiah lainnya! Ada juga benefit anggota eksklusif, undian poin, dan event benefit lainnya",
    "213dzgVipRule6" : "Silakan nantikan.",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "Tautkan Akun/Hapus Tautan",
    "unbindApply" : "Mengajukan Hapus Tautan",
    "unbindConfirmTitle" : "Yakin mau Hapus Tautan?",
    "unbindConfirmTip" : "Apakah Anda yakin mau Hapus Tautan akun pihak ketiga? Kemungkinan menyebabkan progres akun hilang",
    "unbindConfirm" : "Ya, Hapus Tautan",
    "unbindExit" : "Tidak, Keluar",
    "unbindSucc" : "Berhasil batal tautan",
    "unbindFail" : "Gagal Hapus Tautan. Silakan hubungi CS",
    "unbindServiceTitle" : "Silakan ajukan Hapus Tautan Manual",
    "unbindContact" : "Hubungi CS",
    "unbindServiceTip" : "Anda tidak sesuai dengan syarat pengajuan Auto Hapus Tautan. Silakan hubungi CS untuk mengajukan Hapus Tautan Manual",
    "antslgType15" : "Legacy",
    "shareEventTitle" : "Undang Teman</br>Nikmati Hadiah",
    "shareRule" : "Aturan",
    "awardBag" : "Tas Hadiahku",
    "initiatorText" : "Aku adalah pengundang",
    "inviteeText" : "Aku diundang",
    "createCode" : "Membuat Kode Undangan",
    "createCodeTip" : "Tekan untuk menghasilkan Kode Undangan eksklusif",
    "createLinkTip" : "Tekan untuk menghasilkan Tautan Undangan eksklusif",
    "copyText" : "Salin",
    "shareCode" : "Bagikan Kode Undangan",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Cek hadiah",
    "seeAwardTip" : "Silakan pergi ke “<span class=\"see-light\">Poin VIP</span>” - “<span class=\"see-light\">Kupon Aku</span>” untuk cek dan penggunaan",
    "inviteReward" : "Hadiah Undang",
    "inviteRewardTip" : "Tidak reset tingkat akumulasi Top up orang diundang",
    "overweightReward" : "Hadiah Bonus",
    "resetTip" : "Reset pada hari terakhir di setiap bulan jam 00:00",
    "rewardText1" : "Akumulasi Top up orang diundang mencapai 9,99USD",
    "rewardText2" : "Akumulasi Top up orang diundang mencapai 49,99USD",
    "rewardText3" : "Akumulasi Top up orang diundang mencapai 99,99USD",
    "rewardText4" : "Setiap mengundang 5 orang, akan mendapat 1 Kupon 12%OFF!",
    "rewardText5" : "Jika orang diundang mencapai 1,000USD total Top up, akan mendapat 1 Kupon 15%OFF!",
    "invitationList" : "Pratinjau Undangan",
    "refresh" : "Refresh",
    "invitedTotal" : "Total undang: \${total} orang",
    "storedTotal" : "Total Top up: \${total} USD",
    "people" : "",
    "invitedPeople" : "Orang diundang",
    "invitedTime" : "Waktu Undang",
    "got" : "Sudah tercapai",
    "get" : "Tidak Tercapai",
    "overlay" : "Bisa akumulasi",
    "couponText" : "Kupon",
    "personalReward" : "Hadiah Top up Personal",
    "personalRewardText1" : "Akumulasi Top up personal mencapai 9,99USD",
    "personalRewardText2" : "Akumulasi Top up personal mencapai 49,99USD",
    "personalRewardText3" : "Akumulasi Top up personal mencapai 99,99USD",
    "inputCode" : "Masukkan Kode Undangan",
    "bindCode" : "Ikat Kode Undangan",
    "bindSucc" : "Telah Terikat",
    "codeTip1" : "Kode Undangan tidak ada. Silakan masukkan ulang",
    "codeTip2" : "Sudah Ikat Kode Undangan",
    "copySucc" : "Disalin",
    "awardName" : "Nama hadiah",
    "getTime" : "Waktu perolehan",
    "getCondition" : "Syarat perolehan",
    "couponText1" : "Kupon 6%off",
    "couponText2" : "Kupon 8%off",
    "couponText3" : "Kupon 10%off",
    "couponText4" : "Kupon 12%off",
    "couponText5" : "Kupon 15%off",
    "ruleText1" : "1. Waktu Event: Mulai tanggal 25/11/2022 (UTC)",
    "ruleText2" : "2. Event game: Puzzles & Survival",
    "ruleText3" : "3. Event “Bagikan Top up Official”: Bagikan dan undang teman gunakan tampilan Top up official. Jika jumlah Top up mencapai jumlah yang ditentukan, bisa klaim hadiah",
    "ruleText4" : "4. Event “Hadiah Bulanan Bagikan Pihak Ketiga”: Mencapai target bagikan setiap bulan bisa klaim hadiah relevan. Hadiah refresh setiap bulan",
    "ruleText5" : "5. Pemain baru hadiah bulanan perlu melakukan Top up di pihak ketiga setelah undang",
    "ruleText6" : "6. Hadiah bulanan diperbarui setiap tanggal 1, progres bulan sebelumnya akan dihapus",
    "ruleText7" : "7. Kupon hadiah perlu login ke pihak ketiga dan klaim di halaman pembayaran. Jika kedaluwarsa, tidak bisa klaim dan tidak dikirim ulang",
    "ruleText8" : "8. Mata uang pesanan Anda yang sukses Top up terakhir kalinya akan menjadi mata uang kupon. Jika perlu ganti mata uang, silakan hubungi CS",
    "ruleText9" : "9. Kedua pemain tidak bisa saling ikat kode undangan satu sama lain",
    "ruleTableTitle1" : "Aturan Bagikan Hadiah seperti berikut ini：",
    "ruleTableTitle2" : "Aturan tingkat VIP dan Kupon Diskon gratis seperti gambar berikut:",
    "ruleTableHead1" : "Standar Top up",
    "ruleTableHead2" : "Standar Hadiah",
    "ruleTableHead3" : "Hadiah",
    "ruleTableContent1" : "Undang pemain baru 5 orang",
    "ruleTableContent2" : "Pemain yang sudah bind melakukan Top up hingga 1,000USD",
    "errorTip" : "Gagal",
    "eventShareText1" : "Puzzles & Survival: Event diskon Sedang Berlangsung",
    "eventShareText2" : "Banyak Benefit Menunggumu",
    "cartDoubleTip" : "Troli Belanja tidak mendukung penggunaan Kupon Multiplier",
    "codeTip3" : "Belum Login",
    "codeTip4" : "Kekurangan parameter",
    "codeTip5" : "Tidak bisa ikat kode undangan sendiri",
    "codeTip6" : "Kode undangan sudah terbentuk",
    "payWelfare" : "Benefit Top up",
    "wallet" : "Dompet",
    "myDiscount" : "Kupon Aku",
    "knowMore" : "Lainnya",
    "backPay" : "Kembali ke",
    "curBalance" : "Saldo",
    "pay" : "Top up",
    "changeCoin" : "Ganti mata uang",
    "watchDesc" : "Cek detail",
    "getMore" : "Dapatkan Lebih",
    "getDiscount" : "Klaim Kupon",
    "notOpenDiscountQuan" : "Event Kupon tidak tersedia saat ini, silakan pantau terus",
    "abountZbit" : "Mengenai \${Z-BIT}",
    "remain" : "Sisa:",
    "payRemain" : "Estimasi sisa setelah bayar",
    "payRemainExpiry" : "Perkiraan sisa setelah pembayaran ${money} (Kadaluarsa 1 Januari 2026, harap segera digunakan)",
    "balanceNotEnoughExpiry" : "Saldo tidak mencukupi (Kedaluwarsa 1 Januari 2026, isi ulang tidak tersedia)",
    "balanceNotEnoggh" : "Kekurangan saldo, silakan Top up",
    "goToPay" : "Pergi Top up",
    "chooseOtherPay" : "Silakan pilih cara pembayaran lain",
    "payIntro" : "Penjelasan Top up",
    "logRole" : "Login karakter",
    "chooseProduct" : "Pilih item",
    "meAgree" : "Saya sudah membaca dan setuju",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "Sebelum menggunakan \${Z-BIT} perlu verifikasi dinamis",
    "dl3dvnVipRule1" : "1. Partisipasi game:  \${gameName}",
    "dl3dvnVipRule2" : "Hanya bisa klaim 1x untuk setiap hadiah Event. Silakan klaim tepat waktu.",
    "dl3dvnVipRule3" : "2. Event “Bonus Kupon Via Login”: Saat login ke halaman Top Up untuk pertama kalinya, bisa klaim Kupon 15% OFF.",
    "dl3dvnVipRule4" : "3. Event “Poin VIP”: Jika poin pembelian item mencapai level relevan di halaman pembayaran official, maka akan mendapat kupon level dan kupon eksklusif mingguan",
    "dl3dvnVipRule5" : "4. Silakan cek rasio setiap mata uang di catatan 1, kurang dari 1 poin tidak dihitung",
    "dl3dvnVipRule6" : "5. Jika pesanan menggunakan kupon, poin akan dikalkulasi berdasarkan pembayaran yang sebenarnya",
    "dl3dvnVipRule7" : "6. Masa berlaku poin adalah 365 hari. Level VIP berubah sesuai poin yang berlaku di saat ini",
    "dl3dvnVipRule8" : "7. Jika mencapai level VIP, bisa langsung klaim kupon perdana & kupon mingguan level baru. Kupon mingguan selanjutnya refresh setiap Sabtu jam 00:00 (UTC+0)",
    "dl3dvnVipRule9" : "8. Perlu login untuk klaim kupon mingguan. Jika terlewat, tidak ada pengiriman ulang. Hadiah kupon akan diperbarui secara berkala",
    "dl3dvnVipRule10" : "9. Jenis mata uang kupon didasarkan pada jenis mata uang pesanan Top up terakhir Anda. Silakan hubungi CS jika perlu tukar jenis mata uang",
    "dl3dvnVipRule11" : "10. Aturan tingkat VIP dan kupon diskon hadiah adalah sebagai berikut:",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. Hak interpretasi akhir adalah milik tim operasional  \${gameName} .",
    "codeTip7" : "Pemain tersebut sudah ikat kode undangan Anda. Anda tidak bisa lagi menggunakan kode undangannya untuk ikat",
    "ruleText10" : "10. Hak interpretasi akhir Event dimiliki Event Puzzles & Survival.",
    "payCoins" : "Poin Top up VIP",
    "shareGift" : "Hadiah Bagikan",
    "attentionCoinUse" : "Perhatian: Saldo mata uang yang berbeda tidak bisa digunakan bersamaan",
    "noPayWay" : "Maaf, tidak ada cara pembayaran yang tersedia di wilayah terpilih. Silakan pilih wilayah dan coba lagi.",
    "dl3dtwVipRule1" : "1. Partisipasi game:  \${gameName}",
    "dl3dtwVipRule2" : "Hanya bisa klaim 1x untuk setiap hadiah Event. Silakan klaim tepat waktu.",
    "dl3dtwVipRule3" : "2. Event “Poin VIP”: Jika poin pembelian item mencapai level relevan di halaman pembayaran official, maka akan mendapat kupon level dan kupon eksklusif mingguan",
    "dl3dtwVipRule4" : "3. Silakan cek rasio setiap mata uang di catatan 1, kurang dari 1 poin tidak dihitung",
    "dl3dtwVipRule5" : "4. Jika pesanan menggunakan kupon, poin akan dikalkulasi berdasarkan pembayaran yang sebenarnya",
    "dl3dtwVipRule6" : "5. Masa berlaku poin adalah 365 hari. Level VIP berubah sesuai poin yang berlaku di saat ini",
    "dl3dtwVipRule7" : "6. Jika mencapai level VIP, bisa langsung klaim kupon perdana & kupon mingguan level baru. Kupon mingguan selanjutnya refresh setiap Sabtu jam 00:00 (UTC+0)",
    "dl3dtwVipRule8" : "7. Perlu login untuk klaim kupon mingguan. Jika terlewat, tidak ada pengiriman ulang. Hadiah kupon akan diperbarui secara berkala",
    "dl3dtwVipRule9" : "8. Jenis mata uang kupon didasarkan pada jenis mata uang pesanan Top up terakhir Anda. Silakan hubungi CS jika perlu tukar jenis mata uang",
    "dl3dtwVipRule10" : "9. Aturan tingkat VIP dan kupon diskon hadiah adalah sebagai berikut:",
    "dl3dtwVipRule11" : "10. Hak interpretasi akhir adalah milik tim operasional  \${gameName} .",
    "eventInviteSucc" : "Berhasil undang.",
    "eventGainCondition" : "Syarat perolehan",
    "eventSuccInvite" : "Berhasil undang teman",
    "eventInviteGainOne" : "Akumulasi Top up orang diundang mencapai 49,99USD",
    "eventInviteGainTwo" : "Akumulasi Top up orang diundang mencapai 99,99USD",
    "eventFriendCode" : "Kode Undangan Teman yang Anda miliki:",
    "eventCheckBind" : "Mau bind?",
    "eventConfirm" : "Konfirmasi",
    "eventCancel" : "Batal",
    "eventBindSucc" : "Berhasil bind!",
    "eventGainCoupon" : "Selamat! Anda mendapat 1 Kupon!",
    "eventLookCoupon" : "Cek Kupon",
    "eventSuccBind" : "Berhasil bind",
    "recaptchaTip" : "Silakan verifikasi dulu",
    "completeRecaptcha" : "Harap selesaikan verifikasi captcha",
    "recaptchaExpired" : "Verifikasi kedaluwarsa, silakan coba lagi",
    "inputAccountName" : "Silakan masukkan akun yang ingin dicari kembali",
    "pwaPayTip" : "Pembayaran yang lebih cepat, pengalaman yang lebih bagus",
    "pwsInstall" : "Tambahkan ke desktop",
    "ztmslgType999" : "Voucher",
    "coinUseTips" : "Voucher akan dikirim via Mail di dalam game, bisa beli item apa pun di Mall Voucher dalam game. Saat konsumsi Voucher, bisa mendapat hadiah akmulasi Top Up",
    "notice" : "Bulletin",
    "popupConfirm" : "Konfirmasi",
    "hideWithinWeek" : "Tidak tampilkan selama 7 hari",
    "ztmslgProductOffTips" : "Akhir-akhir ini kami menerima banyak saran dari banyak pemain antusias terhadap update halaman pembayaran yang akan segera datang. Kami sangat menghargai pendapat pemain. Keputusan saat ini: Perubahan yang dijadwalkan pada tanggal 13/3 akan dibatalkan. Kami akan terus mengoptimalkan pengalaman belanja untuk Anda, terima atas pengertian dan dukungan Anda! Jika ada masalah, silakan hubungi CS.",
    "couponTopLimit" : "Limit diskon berbagai mata uang",
    "swsjpVipRule1" : "1. Waktu Event: 24/03/2023 00:00 (UTC)",
    "swsjpVipRule2" : "2. Partisipasi game: {\${gameName}}",
    "swsjpVipRule3" : "Hanya bisa klaim 1x untuk setiap hadiah Event. Silakan klaim tepat waktu.",
    "swsjpVipRule4" : "3. Event “Bonus Kupon Via Login”: Saat login ke halaman Top Up untuk pertama kalinya, bisa klaim Kupon 15% OFF.",
    "swsjpVipRule5" : "4. Event “Poin VIP”: Jika poin pembelian item mencapai level relevan di halaman pembayaran official, maka akan mendapat kupon level dan kupon eksklusif mingguan",
    "swsjpVipRule6" : "5. Silakan cek rasio setiap mata uang di catatan 1, kurang dari 1 poin tidak dihitung",
    "swsjpVipRule7" : "6. Jika pesanan menggunakan kupon, poin akan dikalkulasi berdasarkan pembayaran yang sebenarnya",
    "swsjpVipRule8" : "7. Riwayat Top up pemain sudah dikonversi ke poin berdasarkan rasio tertentu",
    "swsjpVipRule9" : "8. Masa berlaku poin adalah 365 hari. Level VIP berubah sesuai poin yang berlaku di saat ini",
    "swsjpVipRule10" : "9. Jika mencapai level VIP, bisa langsung klaim kupon perdana & kupon mingguan level baru. Kupon mingguan selanjutnya refresh setiap Sabtu jam 00:00 (UTC+0)",
    "swsjpVipRule11" : "10. Perlu login untuk klaim kupon mingguan. Jika terlewat, tidak ada pengiriman ulang. Hadiah kupon akan diperbarui secara berkala",
    "swsjpVipRule12" : "11. Jenis mata uang kupon didasarkan pada jenis mata uang pesanan Top up terakhir Anda. Silakan hubungi CS jika perlu tukar jenis mata uang",
    "swsjpVipRule13" : "12. Hak interpretasi akhir adalah milik tim operasional \${gameName}.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Voucher",
    "passAskMods" : "Tanya ke mod",
    "passAskModsTip" : "Bisa tanya ke mod mengenai hal yang terkait game",
    "passService" : "Hubungi CS",
    "passServiceTip" : "Bisa hubungi CS mengenai akun, Top Up dan masalah lain",
    "passIKonw" : "Aku Mengerti",
    "passGoOn" : "Lanjutkan Tanya",
    "voucherTitle" : "Pusat Top Up Official",
    "voucherAddHome" : "Tambahkan ke desktop",
    "voucherAddHomeTipOne" : "Pembayaran yang lebih cepat, pengalaman yang lebih bagus",
    "voucherAddHomeTipTwo" : "Tekan [Share] di toolbar",
    "voucherAddHomeTipThree" : "Pilih [Tambahkan ke desktop]",
    "voucherLoginLook" : "Log in untuk cek diskon",
    "voucherSwitchRole" : "Ganti Karakter",
    "voucherCoupon" : "Kupon",
    "voucherVip" : "Poin VIP",
    "voucherMoreCoupon" : "Benefit lainnya",
    "voucherAccountId" : "ID Akun",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "Gunakan metode pembayaran lainnya",
    "voucherOtherLoginWay" : "Gunakan metode Log in lainnya",
    "voucherCouponActivity" : "Event Diskon",
    "voucherActivityNotBegin" : "Event belum dimulai, silakan nantikan",
    "voucherGoCommunity" : "Pergi ke komunitas untuk memahami lebih banyak benefit Top Up",
    "voucherValidTime" : "Masa berlaku",
    "voucherLimitRegion" : "Hanya untuk \${currency}",
    "voucherLiuyi" : "Kupon tidak tersedia, harap perhatikan info Event Official",
    "voucherPay" : "Beli Voucer",
    "voucherAbout" : "Mengenai Voucer",
    "voucherChooseWay" : "Pilih Metode Pembayaran",
    "voucherMoreWay" : "Metode lainnya",
    "voucherChooseCoupon" : "Pilih Kupon",
    "voucherHasChoose" : "Terpilih",
    "voucherMoneyInsufficient" : "Saldo kurang",
    "voucherContact" : "Saldo kurang. Silakan hubungi CS",
    "voucherCouponTotal" : "Kupon valid tersedia",
    "voucherCouponTipGuide" : "Setelah pilih metode pembayaran, pilih Kupon saat pembayaran",
    "voucherPaytypeNotSupport" : "Metode pembayaran saat ini tidak mendukung penggunaan Kupon",
    "voucherTipSideOne" : "Voucher bisa tukar semua paket hadiah dan layanan nilai tambah dalam game ini kecuali voucher",
    "voucherTipSideTwo" : "Maksimal 15% diskon",
    "voucherYue" : "Saldo",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Survival Manual",
    "vipHeadText" : "VIP exclusive frame unlocked",
    "vipHeadGetText" : "Claim",
    "vipHeadGotText" : "Claimed",
    "vipHeadGetTitle" : "Confirm",
    "vipHeadGetTip" : "This reward can only be claimed once per account. Continue?",
    "vipHeadAwardText" : "Gold Commander (Permanen)",
    "vipHeadGetErrTip1" : "Failed. Please try again or contact CS.",
    "cartGuideTipNew" : "Lebih banyak pembayaran, nikmati diskon bersama",
    "newVipTitle" : "Pusat Top Up Situs Resmi Eksklusif VIP",
    "newVipLogin" : "Log in",
    "newVipNowPoint" : "Poin:",
    "newVipNextLevel" : "Level berikutnya: Perlu \${point} poin",
    "newVipUpgrade" : "Tingkatkan sekarang",
    "newVipLevel" : "Benefit Level VIP",
    "newVipTip" : "Hadiah Kupon akan refresh setiap Sabtu UTC 0. Saat Log in ke halaman Top Up Situs Resmi, akan kirim otomatis.",
    "newVipWeekly" : "Bonus Mingguan",
    "newVipReachPoint" : "Syarat:",
    "newVipRuleInfo" : "Aturan:",
    "pleaseLang" : "Silakan pilih bahasa",
    "reference" : "Nomor Order",
    "saveToNext" : "Simpan untuk penggunaan berikutnya",
    "cardNum" : "Nomor Kartu",
    "expireTime" : "Masa berlaku",
    "CVV" : "Kode Keamanan",
    "pleaseCard" : "Pilih tipe kartu kredit",
    "howToPay" : "Bagaimana cara Anda membayar?",
    "checkCard" : "Silakan periksa nomor kartu",
    "checkExpiryDate" : "Silakan periksa masa berlaku",
    "checkCVV" : "Silakan periksa kode keamanan",
    "addCard" : "Tambahan",
    "delete" : "Hapus",
    "deleteCardTips" : "Hapus data kartu kredit yang tersimpan",
    "confirmDelete" : "Ya, hapus",
    "cancelDelete" : "Batal",
    "checkAllCardMsg" : "Silakan periksa nomor kartu, masa berlaku, kode keamanan",
    "leaveCreditPageTips" : "Meninggalkan halaman akan menggagalkan pembayaran pesanan gagal, yakin pergi?",
    "sureToLeave" : "Konfirmasi Pergi",
    "continueToPay" : "Lanjutkan Pembayaran",
    "pushTest" : "Tes Rekomendasi",
    "getNoticication" : "Perangkat tidak bisa menerima pemberitahuan rekomendasi?",
    "waitCheckResult" : "Silakan tunggu hasil deteksi untuk mengetahui penyebabnya~",
    "hadAbnormal" : "Ada gangguan pada deteksi sehingga tidak bisa terima rekomendasi.",
    "clickIntro" : "Silakan tekan opsi gangguan untuk cek panduan solusi",
    "networkCheck" : "Deteksi lingkungan internet",
    "noticeAuthorityCheck" : "Deteksi izin pemberitahuan",
    "noticeBtnCheck" : "Deteksi On/Off Pemberitahuan",
    "gmsCheck" : "Deteksi layanan GMS",
    "batteryCheck" : "Deteksi daftar optimalisasi baterai",
    "pushServiceCheck" : "Deteksi rekomendasi server",
    "reCheck" : "Deteksi Ulang",
    "noNoticeAuthorityTip" : "Perangkat belum beri izin untuk pemberitahuan dari game. Silakan buka izin di Settings - Notifications, pilih game dan buka izin.",
    "noNoticeBtnTip" : "On/Off Pemberitahuan game belum dibuka. Silakan buka On/Off Pemberitahuan game di Settings",
    "noBatteryTip" : "Game berada dalam daftar optimalisasi baterai, mungkin tidak bisa menerima rekomendasi. Silakan tambahkan game ke whitelist di Settings - Battery - Battery Optimization.",
    "noPushServiceTip" : "Gagal terhubung ke server rekomendasi. Silakan tekan [Hubungkan] untuk menghubungkan ke server",
    "noNetworkTip" : "Ada gangguan pada jaringan. Silakan coba lagi setelah internet stabil",
    "noGmsTip" : "Perangkat ini tidak mendukung layanan seluler GMS Google. Silakan login di perangkat yang mendukung layanan GMS untuk terima pemberitahuan",
    "pushConnectFail" : "Gagal terhubung ke server rekomendasi",
    "pushConnectSucc" : "Berhasil terhubung ke server rekomendasi",
    "noGetPushTitle" : "Jika masih tidak bisa terima rekomendasi dari game. Silakan cek via langkah berikut:",
    "noGetPushContOne" : "1. Setelah logout dari game di perangkat saat ini, login lagi akun di game;",
    "noGetPushContTwo" : "2. Tekan [Tes Rekomendasi] akan otomatis kirim testing. Harap perhatikan perangkat tersebut bisa terima atau tidak;",
    "noGetPushContThree" : "3. Jika perangkat bisa terima rekomendasi dari hasil tes, tapi tidak bisa terima rekomendasi dari game. Silakan cek apakah opsi pemberitahuan sudah terbuka di game - Settings - Notifications;",
    "noGetPushContFour" : "4. Jika tetap tidak bisa terima rekomendasi setelah melakukan langkah di atas, silakan hubungi CS.",
    "getPushSucc" : "Perangkat berhasil menerima rekomendasi tes terakhir, fitur rekomendasi berstatus normal!",
    "allCheckSucc" : "Semua opsi deteksi berstatus normal!",
    "pushCheck" : "Deteksi Rekomendasi",
    "useDirectPay" : "Gunakan Pembayaran Pintas",
    "paypalFraudnetInfo" : "Pembayaran aman via Paypal",
    "goToSetting" : "Pengaturan",
    "retry" : "Coba Lagi",
    "connect" : "Hubungkan",
    "canRebind" : "Setelah batal tautan, Anda bisa tautkan ulang",
    "agreePlatform" : "Aku sudah menyetujui \${service} dan \${privite}",
    "sendGameNews" : "Follow info terbaru game",
    "canNotBindEmail" : "Setelah batal tautan, tidak bisa lagi login via email ini",
    "canNotBindPhone" : "Setelah batal tautan, tidak bisa lagi login via nomor ponsel ini",
    "canChangeByEmail" : "Bisa login di perangkat berbeda via email",
    "canChangeByPhone" : "Bisa login di perangkat berbeda via nomor ponsel",
    "loginSucc" : "Berhasil Log In",
    "phoneHadBind" : "Nomor ponsel ini sudah ditautkan, mau login?",
    "emailHadBind" : "Akun email ini sudah ditautkan, mau login?",
    "phoneNotBind" : "Nomor ponsel ini belum ditautkan, mau buat akun baru?",
    "emailNotBind" : "Akun email ini belum ditautkan, mau buat akun baru?",
    "emailAccount" : "Akun email",
    "phoneAccount" : "Nomor ponsel",
    "phoneInputError" : "Kesalahan format nomor ponsel",
    "registerNewAccount" : "Registrasi akun baru",
    "secureTip" : "Account Safety Tips",
    "toTop" : "Tempatkan ke atas",
    "createNewWork" : "Tiket Baru",
    "serviceEvaluate" : "Nilai CS",
    "emailRemind" : "Notifikasi",
    "isAgreeService" : "Apakah Anda puas dengan layanan kami?",
    "thankEvaluateTop" : "Terima kasih atas penilaian Anda!",
    "inputValidEmail" : "Masukkan alamat e-mail valid",
    "replyWillRemind" : "Setelah dibalas CS, e-mail Anda akan menerima mail notifikasi. Jika ingin batalkan fitur ini, silakan tekan lagi fitur Notifikasi.",
    "isCancelEmailRemind" : "Mau batalkan notifikasi? Setelah dibatalkan, tidak bisa lagi terima mail notifikasi~",
    "reconfirmEmail" : "Silakan konfirmasi e-mail",
    "confirmCanSubmit" : "Bisa kirim tiket setelah konfirmasi",
    "serviceWillReply" : "Akan mendapat mail notifikasi setelah dibalas CS",
    "cancelEmailRemind" : "Apakah Anda mau batalkan [Mail Notifikasi]?",
    "yes" : "Ya",
    "no" : "Tidak",
    "inputWorkSearch" : "Silakan masukkan kata kunci",
    "loading" : "Memuat...",
    "loadingError" : "Gagal memuat. Silakan tekan untuk muat ulang...",
    "noMore" : "Tidak ada lagi",
    "cancelToTop" : "Batal Tempatkan",
    "evaluateOne" : "Netral",
    "evaluateTwo" : "Bagus",
    "evaluateThree" : "Sangat bagus",
    "evaluateFour" : "Puas",
    "evaluateFive" : "Sangat puas",
    "confirmDelWorkTop" : "Mau hapus tiket ini?",
    "reRemindEmail" : "Mau ingatkan Anda via e-mail? Anda bisa tekan [Notifikasi].",
    "confirmWillReply" : "Setelah konfirmasi, akan mendapat mail notifikasi setelah dibalas CS",
    "thankEvaluateBottom" : "Penilaian Anda adalah motivasi kami!",
    "confirmDelWorkBottom" : "Tidak bisa dibalas setelah hapus~",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Berhasil unggah video",
    "videoUploadFail" : "Gagal unggah video",
    "videoUploadLimit" : "Hanya bisa unggah video format mp4, ukuran file tidak boleh melebihi 400mb, durasi video tidak boleh melebihi 2 menit.",
    "imageUploadSucc" : "Berhasil unggah gambar",
    "imageUploadFail" : "Gagal unggah gambar",
    "uploading" : "Sedang unggah",
    "smartOrderCreate" : "Buat tiket cepat",
    "smartOrderSearch" : "Cari",
    "smartOrderComing" : "Silakan nantikan",
    "smartOrderContactService" : "Hubungi CS",
    "smartOrderDetector" : "Asisten Analisis",
    "smartOrderDetect" : "Analisis",
    "smartOrderDetecting" : "Menganalisis",
    "smartOrderDetectTip" : "Terdeteksi game mengalami masalah saat Anda bermain. Silakan tekan Analisis dan kami akan bantu identifikasi masalahnya.",
    "smartOrderDetectTip2" : "Sudah identifikasi masalah untuk Anda. Setelah kirim tiket, kami akan bantu selesaikan masalah!",
    "smartOrderSubmit" : "Kirim",
    "smartOrderIKnow" : "Mengerti",
    "smartOrderConfirm" : "Konfirmasi",
    "smartOrderLook" : "Cek",
    "smartOrderIsHelp" : "Apakah artikel ini membantu Anda?",
    "smartOrderInputQuestion" : "Masukkan masalah Anda",
    "smartOrderPleaseInpt" : "Silakan masukkan",
    "smartOrderPleaseChoose" : "Silakan pilih",
    "smartOrderStoreTime" : "Waktu Top Up",
    "smartOrderInputOrder" : "Silakan masukkan Nomor Order",
    "smartOrderInputPrice" : "Silakan masukkan nilai Order",
    "smartOrderNeedHelp" : "Halo, perlu bantuan?",
    "smartOrderLookHelpTip" : "Anda bisa cek solusi untuk pertanyaan umum",
    "smartOrderNoResult" : "Tidak ada hasil pencarian. Silakan coba cari konten lain",
    "smartOrderUpdateTime" : "Waktu ubah terakhir",
    "smartOrderSelectStoreTime" : "Silakan pilih waktu Top Up",
    "smartOrderAtlestChoose" : "Setidaknya mengisi 1 opsi",
    "workHomeTitle": "Pusat Layanan Pelanggan",
    "workHomeCurServer": "Server Saat Ini",
    "workHomeSearchPlaceholder": "Masukkan kata kunci untuk menemukan jawaban dengan cepat",
    "workHomeSelfService": "Swalayan",
    "workHomeAiService": "Layanan Pelanggan Cerdas",
    "workHomeArtificialService": "Layanan Manusia",
    "workHomeServiceEntrance": "Kami siap melayani Anda",
    "pwaInstallAward" : "Add Shortcut",
    "getMasonry" : "Claim Diamond",
    "addToDrawerVisit" : "Add a shortcut so you can easily find it again.",
    "immeAddToGet" : "Add shortcut now to claim limited rewards.",
    "add" : "Add Shortcut",
    "talkNextTime" : "Later",
    "chooseRoleGetGift" : "Select your character to claim rewards",
    "getGiftSuccess" : "Claimed. Go check your rewards in the game.",
    "dmaTitle" : "Iklan yang Dipersonalisasi",
    "dmaTitleSub" : "(Opsional)",
    "newAdd" : "Tambahan",
    "smartDelete" : "Hapus",
    "wordLengthTip" : "(0-600 huruf)",
    "areaLimitSwitchRegion" : "Ganti Area",
    "areaLimitCurrentRegionCurrency" : "Area saat ini dan mata uang pembayaran",
    "areaLimitRegion" : "Area:",
    "areaLimitCurrency" : "Mata uang pembayaran:",
    "areaLimitNote" : "Perhatian:",
    "areaLimitSwitchLimitation" : "Setiap akun bisa ubah 1x area dalam setiap 12 bulan",
    "areaLimitPostSwitchCoupon" : "Setelah ubah, Kupon yang baru didapatkan akan dikirim berdasarkan mata uang area baru.",
    "areaLimitRemainingSwitches" : "Sisa: \${times}",
    "areaLimitNoRemainingSwitches" : "Tidak ada tersisa",
    "areaLimitUnableToSwitchThisYear" : "Tidak bisa ubah lagi di tahun ini",
    "areaLimitCannotSwitch" : "Tidak bisa ubah",
    "areaLimitNavigateToSwitch" : "Ubah",
    "areaLimitConfirmSwitch" : "Konfirmasi",
    "areaLimitPreSwitchRegionCurrency" : "Ubah area saat ini dan mata uang pembayaran",
    "areaLimitPostSwitchRegionCurrency" : "Area dan mata uang pembayaran setelah ubah",
    "areaLimitPostSwitchRestriction" : "Setelah ubah, tidak bisa ubah lagi area pembayaran di tahun ini.",
    "areaLimitUnusedZBitWarning" : "Masih ada Z-Bit yang belum Anda gunakan. Setelah ubah area, mungkin tidak bisa menggunakan Z-Bit, lanjut?",
    "areaLimitConfirm" : "Konfirmasi",
    "areaLimitCancel" : "Batal",
    "areaLimitInconsistencyWarning" : "Area akses Anda dan area pembayaran tidak sama",
    "areaLimitPromptToSwitch" : "Mau ubah area?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Claim Reward",
    "selectProductTitle" : "Pilih item",
    "hotSuggest" : "Populer",
    "inputKeywordSearch" : "Cari...",
    "lookProductContent" : "Detail",
    "popupClose" : "Tutup",
    "productSwitch" : "Ganti",
    "confirmBuy" : "Beli",
    "thinkLater" : "Nanti",
    "areaLimitConfirmRegion" : "Konfirmasi area",
    "areaLimitContinuePay" : "Lanjutkan pembayaran",
    "areaLimitSwitchLimitationTwice" : "Setiap akun bisa ubah 2x area dalam setiap 12 bulan",
    "dtmslgVipRule1" : "1. Partisipasi game:  \${gameName}",
    "dtmslgVipRule2" : "Hanya bisa klaim 1x untuk setiap hadiah Event. Silakan klaim tepat waktu.",
    "dtmslgVipRule3" : "2. Event “Poin VIP”: Jika poin pembelian item mencapai level relevan di halaman pembayaran official, maka akan mendapat kupon level dan kupon eksklusif mingguan",
    "dtmslgVipRule4" : "3. Silakan cek rasio setiap mata uang di catatan 1, kurang dari 1 poin tidak dihitung",
    "dtmslgVipRule5" : "4. Jika pesanan menggunakan kupon, poin akan dikalkulasi berdasarkan pembayaran yang sebenarnya",
    "dtmslgVipRule6" : "5. Masa berlaku poin adalah 365 hari. Level VIP berubah sesuai poin yang berlaku di saat ini",
    "dtmslgVipRule7" : "6. Jika mencapai level VIP, bisa langsung klaim kupon perdana & kupon mingguan level baru. Kupon mingguan selanjutnya refresh setiap Sabtu jam 00:00 (UTC+0)",
    "dtmslgVipRule8" : "7. Perlu login untuk klaim kupon mingguan. Jika terlewat, tidak ada pengiriman ulang. Hadiah kupon akan diperbarui secara berkala",
    "dtmslgVipRule9" : "8. Jenis mata uang kupon didasarkan pada jenis mata uang pesanan Top up terakhir Anda. Silakan hubungi CS jika perlu tukar jenis mata uang",
    "dtmslgVipRule10" : "9. Aturan tingkat VIP dan kupon diskon hadiah adalah sebagai berikut:",
    "dtmslgVipRule11" : "10. Hak interpretasi akhir adalah milik tim operasional  \${gameName} .",
    "dtmslgType10010" : "Diskon Harian",
    "dtmslgType10020" : "Penawaran Terbatas",
    "dtmslgType10030" : "Hero",
    "dtmslgType10040" : "Battle Gear",
    "dtmslgType10050" : "Rune",
    "dtmslgType10060" : "Totem",
    "dtmslgType10070" : "Batu Suci",
    "dtmslgType10080" : "Naga",
    "dtmslgType10090" : "Sumber Daya",
    "dtmslgType10100" : "Konstruksi & Riset",
    "dtmslgType10110" : "Item Langka",
    "dtmslgType10120" : "Senjata Takdir",
    "dtmslgType10130" : "Diamond",
    "dtmslgType10140" : "Voucher",
    "dtmslgType2" : "Paket Event",
    "dtmslgType3" : "Pusat Hadiah",
    "dtmslgType4" : "Keluarkan Paket",
    "dtmslgType5" : "Paket Tampilan Utama",
    "dtmslgType20010" : "Paket Black Friday",
    "dtmslgType20021" : "Hadiah 5 Hari",
    "dtmslgTypeother" : "Lainnya",
    "rightsIntro" : "",
    "213RightsIntro": "Karena ganti fitur baru, event “Poin VIP” akan segera dihapus.<br/>\n" +
        "Harap Anda segera gunakan Kupon dari “Poin VIP” agar tidak melewati masa berlaku Kupon.<br/>\n" +
        "Waktu hapus: 19/8/2024 08:00:00 (UTC)<br/>\n" +
        "Setelah event dihapus, Anda bisa menuju ke Pusat Anggota untuk mencoba lebih banyak benefit.<br/>\n" +
        "Selesaikan misi untuk mendapatkan poin, gunakan poin bisa menukar kupon, item game, dan hadiah lainnya! Ada juga benefit anggota eksklusif, undian poin, dan event benefit lainnya<br/>\n" +
        "Silakan nantikan.",
    "263RightsIntro": "Karena ganti fitur baru, event “Poin VIP” akan segera dihapus.<br/>\n" +
        "Harap Anda segera gunakan Kupon dari “Poin VIP” agar tidak melewati masa berlaku Kupon.<br/>\n" +
        "Waktu hapus: 28/9/2024 00:00:00 (UTC)<br/>\n" +
        "Setelah event dihapus, Anda bisa menuju ke Pusat Anggota untuk mencoba lebih banyak benefit.<br/>\n" +
        "Selesaikan misi untuk mendapatkan poin, gunakan poin bisa menukar kupon, item game, dan hadiah lainnya! Ada juga benefit anggota eksklusif, undian poin, dan event benefit lainnya<br/>\n" +
        "Silakan nantikan.",
    "goToRights" : "Pergi ke Pusat Anggota Utama",
    "oldVipIntro" : "Harap Anda segera gunakan Kupon dari “Poin VIP” agar tidak melewati masa berlaku Kupon.",
    "pwa-20001" : "Silakan login",
    "pwa-20002" : "Parameter Salah",
    "pwa-20003" : "Belum bind karakter",
    "pwa-20004" : "Gagal kirim hadiah. Silakan coba ulang atau hubungi CS",
    "pwa-20005" : "Anda sudah klaim paket itu",
    "pwa-20100" : "Event belum dimulai",
    "pwa-20101" : "Event Berakhir",
    "pwa-20102" : "Bukan waktu klaim hadiah",
    "pwa-20103" : "Waktu klaim hadiah telah berakhir",
    "pwa-1001" : "Aksi terlalu sering",
    "pwaCommon" : "Silakan coba lagi nanti",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Pusat Top Up Official",
    "headerSafeTip": "Aman dan Bebas Risiko Transaksi instan",
    "safeChecking": "...scan lingkungan pembayaran saat ini",
    "safeChecked": "Aman digunakan",
    "riskChecked": "Potensi risiko terdeteksi, diproses dengan hati-hati",
    "footerSafeTitle1": "Aman",
    "footerSafeTitle2": "Nyaman",
    "footerSafeTitle3": "Hemat",
    "footerSafeTitle4": "Efisien",
    "footerSafeContent1": "Pusat Top Up Official",
    "footerSafeContent2": "Mendukung berbagai metode pembayaran",
    "footerSafeContent3": "Penawaran diskon, banyak benefit waktu terbatas",
    "footerSafeContent4": "Transaksi instan, tidak tunda",
    "limitedTimeActivityTitle" : "Keuntungan Terbatas",
    "limitedTimeActivityTime" : "Waktu Event:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Saat ini \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Kurs dapat berfluktuasi, harap mengacu pada yang ditampilkan di halaman ini)",
    "limitedTimeActivityNotAchieve" : "Belum Selesai",
    "limitedTimeActivityClaim" : "Ambil",
    "limitedTimeActivityClaimed" : "Sudah Ambil",
    "limitedTimeActivityTimeLeft" : "Terbatas: \${days}d \${hours}:\${minutes}:\${seconds}",
    "limitedTimeActivityRecord" : "Riwayat Ambil",
    "limitedTimeActivityAward" : "Hadiah",
    "limitedTimeActivityGotTime" : "Waktu Pengambilan",
    "limitedTimeActivityGotRole" : "Karakter yang Mengambil",
    "limitedTimeActivityRule" : "Aturan Event",
    "limitedTimeActivity285Rule1" : "1. Waktu Event:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. Selama Event, selesaikan Misi waktu terbatas untuk ambil hadiah. Misi dibagi menjadi Misi Mingguan dan Misi Bulanan:",
    "limitedTimeActivity285Rule3" : "(1) Misi Mingguan: Setiap akun hanya dapat menyelesaikan sekali, Reset setiap Senin pukul 00:00.",
    "limitedTimeActivity285Rule4" : "Misi Login Mingguan: Dalam waktu terbatas, selesaikan satu kali login ke halaman saldo situs resmi;",
    "limitedTimeActivity285Rule5" : "Menyelesaikan pengisian saldo dengan jumlah berapa pun: Dalam waktu terbatas, selesaikan satu kali pengisian saldo di halaman saldo situs resmi dengan jumlah berapa pun untuk menyelesaikan Misi.",
    "limitedTimeActivity285Rule6" : "(2) Misi Mingguan: Setiap akun hanya dapat menyelesaikan sekali, Reset setiap bulan di tanggal 1, pukul 00:00.",
    "limitedTimeActivity285Rule7" : "Misi Login: Dalam waktu terbatas, selesaikan satu kali login ke halaman saldo situs resmi;",
    "limitedTimeActivity285Rule8" : "Misi Akumulasi Saldo: Dalam waktu terbatas, di halaman penyimpanan situs resmi, akumulasi saldo mencapai tingkat Misi untuk menerima satu hadiah.",
    "limitedTimeActivity285Rule9" : "Perhatian: Karena durasi Event yang cukup lama, kurs mungkin mengalami perubahan. Harap periksa jumlah Saldo berdasarkan yang ditampilkan di halaman.",
    "limitedTimeActivity285Rule10" : "3. Sebelum menerima hadiah, pilih satu karakter untuk ambil hadiah tersebut. Setelah diterima, harap cek hadiah di dalam game.",
    "limitedTimeActivityClaimAward" : "Ambil Hadiah",
    "limitedTimeActivityConfirmGot" : "Konfirmasi Ambil",
    "limitedTimeActivityGetSucc" : "Berhasil Ambil",
    "limitedTimeActivityGetFail" : "Gagal ambil, harap coba lagi nanti atau hubungi CS",
    "limitedTimeActivityFrequent" : "Jangan melakukan operasi berulang",
    "limitedTimeActivityLoginFirst" : "Silakan login dulu",
    "limitedTimeActivityWrongParam" : "Kesalahan parameter",
    "limitedTimeActivityOverTips" : "Event telah kedaluwarsa, harap refresh halaman",
    "preRightsIntro" : "Karena ganti fitur baru, event “Poin VIP” akan segera dihapus.<br/>Waktu hapus: \${offLineDate}<br/>Harap Anda segera gunakan Kupon dari “Poin VIP” agar tidak melewati masa berlaku Kupon.<br/>Setelah event dihapus, Anda bisa menuju ke Pusat Anggota untuk mencoba lebih banyak benefit.<br/>Selesaikan misi untuk mendapatkan poin, gunakan poin bisa menukar kupon, item game, dan hadiah lainnya! Ada juga benefit anggota eksklusif, undian poin, dan event benefit lainnya<br/>Silakan nantikan.",
    "riskTipTitle" : "Waspada terhadap perilaku ilegal dan risiko penipuan",
    "riskTipContent" : "Pemain terhormat,\n\nSaat ini, kami menyadari sebagian pemain melakukan perilaku ilegal di dalam game yang merusak ketertiban dan keadilan permainan. Perilaku yang sering terjadi meliputi:\n\n1. Mempublikasikan iklan ilegal: Mempublikasikan iklan ilegal via chat dan channel lain, seperti transaksi sumber daya ilegal, jasa Top up, dan lainnya.\n2. Menggunakan plug-in atau skrip: Menggunakan plug-in atau skrip dan teknis lainnya dalam game yang melanggar peraturan dengan tujuan mendapatkan banyak sumber daya;\n3. Undangan ilegal: Mengirim undangan ilegal yang tidak berhubungan dengan konten game selama chat, dan berkontak via channel di luar game (seperti Line, Discord);\n4. Jasa Top up ilegal: Memancing pemain dengan diskon Top up agar pemain melakukan Top up di luar official;\n5. Bentuk penipuan lainnya, seperti meniru identitas official, dan lainnya.\n\nKami ingin mengingatkan semua pemain untuk melindungi properti dan informasi pribadi masing-masing dan jangan pernah memercayai informasi ilegal atau penipuan apa pun. Ada banyak risiko dalam pelanggaran yang disebutkan di atas, bukan hanya membuat akun Anda terkena berisiko hilang karena dicuri, juga mungkin melibatkan penipuan. Kami tidak memberikan kompensasi apa pun terhadap kerugian yang ditimbulkan karena perilaku yang melanggar aturan.\n\nUntuk akun yang melanggar peraturan, kami akan mengambil tindakan berdasarkan tingkat keseriusan dan cakupan pelanggaran, termasuk namun tidak terbatas pada peringatan, menyita keuntungan ilegal, blokir sementara atau permanen pada akun game, dan lainnya. Jika Anda menemukan perilaku mencurigakan dalam game, Anda dapat melaporkannya kepada CS kami. Kami akan mengonfirmasi sesegera mungkin dan mengambil tindakan tepat waktu. Terima kasih atas pengertian dan dukungan Anda.",
    "linkValid": "Tautan ini sudah tidak berlaku",
    "-" : "-",
    "accountLabel": "Akun",
    "passwordLabel": "Kata Sandi",
    "confirmPasswordLabel": "Konfirmasi Kata Sandi",
    "confirmDeleteTitle" : "Silakan konfirmasi apakah ingin hapus akun game dan semua karakter akun",
    "confirmDeleteYes" : "Ya, aku ingin hapus akun game dan semua karakter akun",
    "selectGame" : "Silakan pilih game",
    "confirmDeleteNo" : "Tidak, aku hanya ingin karakter tertentu, pertahankan akun game",
    "delTermsTitle" : "Harap Anda baca dengan teliti syarat hapus akun dan hal yang perlu diketahui",
    "delCondTitle" : "1. Syarat Hapus Akun",
    "delCond1" : "(1) Akun game tersebut dan karakter game yang dimiliki akun didaftarkan dan digunakan oleh Anda. <span>Silakan login akun sebelum melakukan pengajuan </span>. Jika tidak bisa login akun, silakan lakukan [Temukan Akun].",
    "delCond2" : "(2) Akun game dan karakter game <span> tidak memiliki risiko keamanan apa pun </span>, termasuk namun tidak terbatas pada: Tidak ada keluhan, laporan, investigasi, arbitrase, tuntutan hukum, dll. yang belum selesai diurus, dan tidak diadukan, dilaporkan, diselidiki, diadili, diadukan, dituntut, dan lainnya.",
    "delCond3" : "(3) Akun game tersebut dan karakter game <span>tidak ada pembayaran apa pun yang belum lunas</span>, termasuk namun tidak terbatas pada pengembalian dana yang belum diselesaikan, langganan yang tidak dibatalkan, dll.",
    "delNoticeTitle" : "2. Wajib Diketahui Sebelum Hapus Akun",
    "delNotice1" : "(1) Pengajuan yang Anda lakukan adalah untuk menghapus akun game dan karakter game yang dimiliki akun. Setelah <span>selesai hapus, tidak bisa login dan tidak bisa dipulihkan</span>.",
    "delNotice2" : "(2) Harap <span> Anda terlebih dahulu melunaskan aset dalam game di akun dan karakter game </span>, termasuk namun tidak terbatas pada item game, token game, langganan dalam game, dll. Setelah aelesai selesai, aset dalam game akan dihapus semua. Setelah server game dihentikan, tidak ada pengembalian dana untuk akun yang dihapus dan karakter akun. \n",
    "delNotice3" : "(3) Setelah akun game dan data karakter dihapus, informasi terkait akun tersebut juga akan dihapus atau dianonimkan. Namun, pemain sendiri diharuskan untuk melepaskan bind informasi login media sosial pihak ketiga (seperti login terkait Facebook, dan lainnya) dan menghapus informasi di platform relevan.",
    "delNotice4" : "(4) Untuk melindungi hak dan kepentingan Anda, kami akan memberi Anda periode penyimpanan selama 14 hari (kecuali peraturan lokal di beberapa wilayah), yang merupakan periode jeda. Selama periode jeda, Anda bisa hubungi CS untuk mengajukan pembatalan hapus.",
    "delNotice5" : "(5) Setelah pengajuan hapus akun Anda berhasil dikirim, kami akan segera membekukannya, namun akan membutuhkan waktu sekitar 1 minggu untuk menghapus datanya, jadi kami akan memberi tahu Anda via email sesegera mungkin setelah penghapusan selesai.",
    "delFormConfirm1" : "Aku telah membaca dan memahami dengan cermat syarat dan konsekuensi penghapusan akun.",
    "delFormConfirm2" : "Tidak ada laporan relevan atau tuntutan hukum yang tertunda pada akun yang aku ajukan untuk dihapus.",
    "delForm" : "Aku telah membaca dan menyetujui <a class=\"account-delete-link\" href=\"javascript:;\"> \"Perjanjian Penghapusan Akun\" </a>",
    "cannotDeleteMsgTitle" : "Penghapusan akun tidak bisa dilakukan",
    "cannotDeleteMsg1" : "Akun tidak dapat dihapus karena akun Anda tidak memenuhi ketentuan berikut:",
    "cannotDeleteMsg2" : "Sistem mendeteksi Anda memiliki keluhan pelanggan yang belum diproses. Silakan ajukan kembali permohonan setelah menyelesaikan keluhan pelanggan.",
    "cannotDeleteMsg3" : "Sistem mendeteksi bahwa Anda memiliki pengembalian dana yang belum diselesaikan sepenuhnya. Harap selesaikan pengembalian dana tersebut sebelum mengajukan permohonan penghapusan akun.",
    "cannotDeleteMsg4" : "Sistem telah mendeteksi Anda sedang diadukan atau dilaporkan oleh pemain lain. Harap tunggu hingga pengaduan selesai dan kirimkan pengajuan lagi.",
    "formCompleted" : "Tiket sudah selesai diisi",
    "formCheckMsg1" : "Tiket Anda telah diisi, harap tunggu CS meninjaunya secara manual lalu membalas tiket tersebut.",
    "formCheckMsg2" : "Anda dapat memeriksa progres tiket di <span class=\"account-delete-link\">[Tiketku]</span>.",
    "delEmailMsg1" : "Apakah Anda ingin diberitahu via email setelah penghapusan selesai?",
    "delEmailMsg2" : "Karena penghapusan akun perlu pemrosesan data dalam jumlah besar, diperlukan waktu sekitar satu minggu untuk menyelesaikan penghapusan secara keseluruhan. Apakah Anda ingin kami memberi tahu Anda via email setelah penghapusan selesai semuanya?",
    "delEmailMsg3" : "Alamat email yang Anda isi hanya digunakan untuk pemberitahuan dan tidak akan digunakan untuk keperluan lain.",
    "delEmailConfirmYes" : "Ya, beri tahu aku via email",
    "delEmailFill" : "Silakan isi email pemberitahuan",
    "delEmailConfirmNo" : "Tidak, tidak perlu pemberitahuan email",
    "delCoolMsg1" : "Apakah Anda ingin memilih periode jeda 14 hari?",
    "delCoolMsg2" : "Selama periode jeda 14 hari, akun Anda akan dibekukan tetapi Anda dapat membatalkan atau menghapus pengajuan. Setelah 14 hari, jika Anda tidak membatalkan, akun akan dihapus dan tidak dapat dipulihkan.",
    "delCoolMsg3" : "Jika Anda memilih untuk tidak memerlukan periode jeda, akun Anda akan dihapus setelah pengajuan selesai dan tidak dapat dipulihkan.",
    "delCoolConfirmYes" : "Ya, aku berharap ada 14 hari periode jeda",
    "delCoolConfirmNo" : "Tidak, aku ingin hapus sekarang",
    "delSecondCheckMsg1" : "Apakah Anda yakin sudah memproses seluruh isi akun Anda dan jalankan periode jeda akun sekarang? Setelah dijalankan, akun Anda tidak dapat login.",
    "delSecondCheckConfirmYes" : "Ya, langsung dimulai",
    "delResMsg1" : "Pengauan penghapusan akun Anda telah dikirimkan. Akun berikut telah dibekukan dan tidak dapat login:",
    "gameName" : "Nama game:",
    "gameAccount" : "Akun game:",
    "delResMsg2" : "<span>Silakan screenshot dan salin informasi akun di atas. Jika Anda perlu memulihkan akun Anda selama periode jeda, ini adalah bukti satu-satunya</span>",
    "delResMsg3" : "Total periode jeda adalah 14 hari, hitungan mundur:",
    "delResMsg4" : "Jika Anda perlu membatalkan pengajuan penghapusan selama periode jeda, silakan tekan [Hubungi CS] di bawah selama periode jeda.",
    "copyAccountInfo" : "Salin Info Akun",
    "delResMsg5" : "Anda telah menyelesaikan pengajuan penghapusan akun, akun Anda saat ini sedang dihapus, sehingga Anda tidak dapat lagi login ke akun Anda.",
    "delResMsg6" : "Karena penghapusan akun memerlukan pemrosesan data dalam jumlah besar dan pemrosesannya memakan waktu, semua jejak akun tidak akan langsung terhapus. Kami akan menyelesaikannya dalam waktu sekitar seminggu.",
    "delResMsg7" : "Jika Anda sudah mengisi alamat email pemberitahuan sebelumnya, kami akan mengirimkan email ke alamat email yang Anda tunjuk.",
    "delResMsg8" : "Jika Anda perlu login lagi ke dalam game, Anda dapat registrasi akun baru dan login lagi.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Saluran Lain",
    "itemWrong" : "Salah isi, silakan masukkan ulang",
    "delRegisterTime" : "Waktu registrasi",
    "delDevice" : "Model Umum Digunakan",
    "delIp" : "IP Umum",
    "delHistoryPayChannel" : "Saluran Isi Ulang Historis",
    "delHistoryPayOrder" : "Nomor pesanan Top up riwayat",
    "delDeleteReason" : "Alasan hapus akun",
    "delPrevStep" : "Sebelumnya",
    "delNextStep" : "Selanjutnya",
    "delSecondCheckMsg2" : "Apakah Anda yakin sudah memproses seluruh isi akun Anda dan jalankan penghapusan akun sekarang? Setelah dijalankan, akun Anda tidak dapat login.",
    "pleaseFillIn" : "Silakan isi info berikut",
    "switchNewVersion": "Beralih ke versi baru",
    "switchNewVersionPlatform": "Platform pembayaran",
    "updateVersionPopupContent": "Untuk memastikan kinerja permainan yang lancar dan mendukung fitur baru di masa mendatang, kami merekomendasikan Anda untuk memperbarui sistem perangkat Anda agar dapat menikmati pengalaman operasi yang lebih stabil dan optimasi kompatibilitas.",
    selectTopupTips:"90% pengguna memilih pusat isi ulang resmi",
    chuzhi: "Top up",
    selectMethods: "Metode Pembayaran",
    landscapeTip2: "Silakan putar ponsel Anda ke mode potret untuk pengalaman yang lebih baik",
    v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
    ckoNotAvailable: 'Kesalahan layanan pembayaran, silakan coba lagi nanti.',
    ckoSubmitFail: 'Pembayaran gagal. Harap periksa informasi Anda atau gunakan kartu lain. Jika sudah terpotong, dana akan dikembalikan ke metode pembayaran asli.',
    gotoFinish: 'Harus dilakukan',
    inAppPurchase: 'Pembelian dalam aplikasi',
}